import React, { useEffect, useRef, useState, useCallback } from "react";
import PropTypes from 'prop-types';
import SideBar from "../../Components/Sidebar";
import Pageheader from "../Container/PageHeader/Pageheader";
import { useSelector } from "react-redux";
import LeftArrow from "../../Assests/Chevron.svg";
import xIcon from "../../Assests/X.svg";
import Tick from "../../Assests/select_audio.svg";
import album from "../../Assests/Gallery.svg";
import drag from "../../Assests/Drag.png";
import Music from "../../Assests/Music.svg";
import Pause from "../../Assests/Pause.png";
import Vector from "../../Assests/Vector.png";
import { MdOutlineContentPaste } from "react-icons/md";
import EditingVideoPlayer from "../../Components/EditingVideoPlayer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { trimVideo, getAudioUploadUrl, fetchVideoFrames, updateAudioUploadStatus } from "../../Services/ShowsApi";
import { getAudioFiles, getMyAudioFiles, deleteExternalAudio } from "../../Services/Editing";
import { useLoader } from "../../Components/LoaderContext";
import { Box, CircularProgress, Tooltip } from "@mui/material";
import Undo from "../../Assests/undo.png";
import Redo from "../../Assests/redo.png";
import trim from "../../Assests/trim.png";
import copy from "../../Assests/copy.png";
import deleteIcon from "../../Assests/deleteIcon.png";
import playButton from "../../Assests/playButton.png";
import TimelineTicks from "../Editing/TimelineTicks.js";
import Question1 from "../../Assests/Question1.png";
import Question2 from "../../Assests/Question2.png";
import Notify from "../../Assests/Notify.png";
import plusbutton from "../../Assests/plusbutton.png";
import samplebg from "../../Assests/samplebg.png";
import play_button from "../../Assests/play_button.png";
import bg_one from "../../Assests/bg_one.png";
import bg_two from "../../Assests/bg_two.png";
import bg_three from "../../Assests/bg-three.png";
import bg_four from "../../Assests/bg_four.png";
import bg_five from "../../Assests/bg_five.png";
import Delete from "../../Assests/Delete.svg";
import "./Editing.css";
import AudioWaveform from "./AudioWaveform";
import ToggleTypeSelector from '../../Components/ToggleTypeSelector';
import AudioSearch from './AudioSearch';
import ErrorModal from "../../Components/ErrorModal";
import VolumeSlider from "./VolumeSlider";
import ChatModal from "../ChatModal";
import KeyboardShortcutsModal from "./KeyboardShortcutsModal";
import AudioClipLabel from "./AudioClipLabel";
import PlayheadMarker from "./PlayheadMarker";

const getBackgroundImage = (index) => {
  const bgIndex = (index % 5) + 1;
  const bgImages = [bg_one, bg_two, bg_three, bg_four, bg_five];
  return bgImages[bgIndex - 1];
};

const formatTime = (timeInSeconds , isAudio = false) => {
  if (!timeInSeconds || isNaN(timeInSeconds)) return isAudio ? "00:00" : "00:00:00";
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);
   if (isAudio) {
    return `${String(minutes + hours * 60).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const AudioIcon = ({ audio, isPlaying, isWaveformLoading, bgImage, onToggle }) => {
  const handleKeyDown = (e) => {
    if (!isWaveformLoading && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onToggle(audio);
    }
  };

  return (
    <Tooltip title={isWaveformLoading ? "Waveform loading, please wait" : ""} placement="right-end">
      <div
        className="audio-icon"
        onClick={() => !isWaveformLoading && onToggle(audio)}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-disabled={isWaveformLoading}
        aria-label={isPlaying ? "Pause audio" : "Play audio"}
        style={{
          cursor: isWaveformLoading ? "not-allowed" : "pointer",
          opacity: isWaveformLoading ? 0.5 : 1,
        }}
      >
        <img src={bgImage} className="background-icon" aria-hidden="true" />
        <img src={isPlaying ? Pause : play_button} className="play-button" aria-hidden="true" />
      </div>
    </Tooltip>
  );
};

const AudioInfo = ({ audio, isSelected, isWaveformLoading, onSelect, onDelete, showDelete = false }) => {
  let tooltipTitle;
  if (isWaveformLoading) {
    tooltipTitle = "Waveform loading please wait";
  } else if (isSelected) {
    tooltipTitle = "Remove from timeline";
  } else {
    tooltipTitle = "Add to timeline";
  }
  
  return (
    <div className="audio-info">
      <div className="audio-wrap">
        <span className="audio-title">{audio.name.replace(/\.[^/.]+$/, "")}</span>
        <span className="audio-duration">{formatTime(audio.duration || 0, true)}</span>
      </div>
      <div className="waveform-add-wrapper">
        <Tooltip title={tooltipTitle} placement="top">
          <div
            className="Vector-button"
            style={{
              cursor: isWaveformLoading ? "not-allowed" : "pointer",
            }}
          >
            <button onClick={() => onSelect(audio)} aria-label={isSelected ? "selected" : "add"} className="icon-button" disabled={isWaveformLoading}>
              <img src={isSelected ? Tick : Vector} alt={isSelected ? "Selected" : "Add"} aria-hidden="true" style={isSelected ? { width: "2.4vh", height: "2.4vh" } : {}} />
            </button>
          </div>
        </Tooltip>
        {showDelete && (
          <Tooltip title="Delete audio file" placement="right-end">
            <div className="delete-audio-wrapper">
              <button 
                onClick={() => onDelete(audio)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onDelete(audio);
                  }
                }}
                aria-label="Delete audio"
                className="delete-audio-icon"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', width: '100%', height: '100%' }}
              >
                <img src={Delete} alt="Delete" aria-hidden="true" style={{ width: '100%', height: '100%' }} />
              </button>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

AudioInfo.propTypes = {
  audio: PropTypes.shape({
    name: PropTypes.string.isRequired,
    duration: PropTypes.number
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  isWaveformLoading: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  showDelete: PropTypes.bool
};


const AudioCopyPasteButton = ({ showPasteIcon, onCopy, onPaste }) => {
  return showPasteIcon ? (
    <Tooltip title="Paste" placement="top">
      <MdOutlineContentPaste color="#F1F1F3" size="2.0vh" onClick={onPaste} style={{ cursor: "pointer" }} />
    </Tooltip>
  ) : (
    <Tooltip title="Copy" placement="top">
      <button
        onClick={onCopy}
        aria-label="Copy audio"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <img src={copy} alt="Copy" aria-hidden="true" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
      </button>
    </Tooltip>
  );
};

AudioCopyPasteButton.propTypes = {
  showPasteIcon: PropTypes.bool.isRequired,
  onCopy: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
};


const VideoCopyPasteButton = ({ showPasteIcon, onCopy, onPaste }) => {
  return showPasteIcon ? (
    <Tooltip title="Paste" placement="top">
      <MdOutlineContentPaste color="#F1F1F3" size="2.4vh" onClick={onPaste} style={{ cursor: "pointer" }} />
    </Tooltip>
  ) : (
    <Tooltip title="Copy" placement="top">
      <button 
        onClick={onCopy} 
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }} 
        aria-label="Copy video"
      >
        <img src={copy} alt="Copy" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
      </button>
    </Tooltip>
  );
};

VideoCopyPasteButton.propTypes = {
  showPasteIcon: PropTypes.bool.isRequired,
  onCopy: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
};


const DisabledCopyButton = () => {
  return (
    <img 
      src={copy} 
      alt="Copy" 
      style={{ opacity: 0.5, cursor: "not-allowed", width: "3.2vh", height: "3.2vh" }} 
      className="edit-settings-left-icon"
      aria-hidden="true"
    />
  );
};

const Editing = () => {
  const info = useSelector((state) => state.info);
  const location = useLocation();
  const navigate = useNavigate();
  const { showId } = useParams();
  const { triggerLoader, hideLoader } = useLoader();

  const { showDetails, roomID, mp4File, bucketName, duration: initialDuration } = location.state || {};

  useEffect(() => {
    if (!showId) {
      console.error("Show ID is missing from URL parameters");
      navigate("/shows");
      return;
    }
  }, [showId, navigate]);
  const MIN_AUDIO_GAP_PERCENT = 0.1;

  const playerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(initialDuration || 0);
  const [duration, setDuration] = useState(initialDuration || 0);
  const [dragging, setDragging] = useState(null);
  const [audioFiles, setAudioFiles] = useState([]);
  const [defaultAudioFiles, setDefaultAudioFiles] = useState([]);
  const [selectedAudios, setSelectedAudios] = useState([]);
  const [audioStartTime, setAudioStartTime] = useState(0);
  const [audioEndTime, setAudioEndTime] = useState(0);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const videoTimelineRef = useRef(null);
  const audioTimelineRef = useRef(null);
  const bottomContainerRef = useRef(null);
  const videoAudioBarRef = useRef(null);
  const topContainerRef = useRef(null);
  const [frames, setFrames] = useState([]);
  const [framesLoading, setFramesLoading] = useState(true);
  const [displayDuration, setDisplayDuration] = useState(0);
  const [activeTab, setActiveTab] = useState("samples");
  const [panOffsets, setPanOffsets] = useState({});
  const [panStartX, setPanStartX] = useState(0);
  const [selectedAudioIndex, setSelectedAudioIndex] = useState(null);


  const getInitialWaveformHeight = () => {
    if (typeof window === "undefined") return 60;
    const vh = window.innerHeight || 800;

    const computed = Math.round(vh * 0.06);
    return Math.max(60, Math.min(180, computed));
  };

  const [waveformHeight, setWaveformHeight] = useState(getInitialWaveformHeight);

  useEffect(() => {
    const handleResize = () => {
      setWaveformHeight(getInitialWaveformHeight());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [copiedAudio, setCopiedAudio] = useState(null);
  const [showPasteIcon, setShowPasteIcon] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [future, setFuture] = useState([]);
  const [isDraggingOperation, setIsDraggingOperation] = useState(false);
  const [initialDragState, setInitialDragState] = useState(null);
  const [toggleButton, setToggleButton] = useState(false);
  const [playState, setPlayState] = useState(false);
  const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(null);
  const audioPlayerRef = useRef(new Audio());
  const [currentPlayTime, setCurrentPlayTime] = useState(startTime);
  const animationRef = useRef(null);
  const playStartTimestampRef = useRef(null);
  const [isDraggingMarker, setIsDraggingMarker] = useState(false);
  const timelineRef = useRef(null);
  const timelineTicksContentRef = useRef(null);
  const [timelineReady, setTimelineReady] = useState(false);
  const [videoMuted, setVideoMuted] = useState(false);
  const [markerPositionPx, setMarkerPositionPx] = useState(0);
  const [isMarkerFollowingPlayback, setIsMarkerFollowingPlayback] = useState(false);
  const [polygonStartTime, setPolygonStartTime] = useState(null);
  const [tempTimeUpdate, setTempTimeUpdate] = useState(startTime);
  const [isDraggingHandle, setIsDraggingHandle] = useState(false);
  const [segments, setSegments] = useState([{ start: 0, end: showDetails?.RunTime, id: "initial", videoAudioVolume: 1 }]);
  const [isVideoSelected, setIsVideoSelected] = useState(false);
  const [videoPanOffset, setVideoPanOffset] = useState(0);
  const [videoPanStartTime, setVideoPanStartTime] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [copiedVideoSegment, setCopiedVideoSegment] = useState(null);
  const [showPasteIconForVideo, setShowPasteIconForVideo] = useState(false);
  const [samplesSearchTerm, setSamplesSearchTerm] = useState('');
  const [myFilesSearchTerm, setMyFilesSearchTerm] = useState('');
  const [filteredDefaultAudios, setFilteredDefaultAudios] = useState([]);
  const [filteredAudioFiles, setFilteredAudioFiles] = useState([]);
  const [draggedSegmentId, setDraggedSegmentId] = useState(null);
  const [currentSegmentIndex, setCurrentSegmentIndex] = useState(0);
  const [sumOfVideoDuration, setSumOfVideoDuration] = useState(showDetails?.RunTime);
  const [sumOfAudioDuration, setSumOfAudioDuration] = useState(0);
  const [totalTimelineDuration, setTotalTimelineDuration] = useState(showDetails?.RunTime);
  const [isWaveformLoading, setIsWaveformLoading] = useState(false);
  const [waveformLoadingStates, setWaveformLoadingStates] = useState({});
  const [playingAudioIndex, setPlayingAudioIndex] = useState(null);
   const [errorModal, setErrorModal] = useState({ open: false, title: "", message: "" });
  const [isEditingRange, setIsEditingRange] = useState(false);
  const [editStartInput, setEditStartInput] = useState("");
  const [editEndInput, setEditEndInput] = useState("");
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [videoAudioVolume, setVideoAudioVolume] = useState(1);
  const [segmentVolumes, setSegmentVolumes] = useState({});
  const [showAudioVolumeSlider, setShowAudioVolumeSlider] = useState(false);
  const [audioVolume, setAudioVolume] = useState(1);
  const [isVideoMuted, setIsVideoMuted] = useState(false);
  const [mutedAudioKeys, setMutedAudioKeys] = useState(new Set());
  const [showShortcuts, setShowShortcuts] = useState(false);
  const [topContainerHeight, setTopContainerHeight] = useState(null);
  const [isTimelineScrolling, setIsTimelineScrolling] = useState(false);
  const [isResizingTimeline, setIsResizingTimeline] = useState(false);
  const [timelineHeight, setTimelineHeight] = useState(null);
  const resizeStartRef = useRef(null);

  useEffect(() => {
    if (selectedAudios.length > 0) {
      const ends = selectedAudios.map((audio) => audio?.audioEndInTimeINVideo).filter((v) => Number.isFinite(v));
      const fallbackEnds = selectedAudios.map((audio) => (Number.isFinite(audio?.audioEndTime) ? audio.audioEndTime : 0));
      const maxAudioEnd = ends.length > 0 ? Math.max(...ends) : Math.max(...fallbackEnds, 0);
      setSumOfAudioDuration(maxAudioEnd);
    } else {
      setSumOfAudioDuration(0);
    }
  }, [selectedAudios.map((a) => a.id).join(","), selectedAudios.length]);

  useEffect(() => {
    const currentVideoDuration = segments.reduce((sum, segment) => {
      return sum + (segment.end - segment.start);
    }, 0);
    setSumOfVideoDuration(currentVideoDuration);
  }, [segments]);

  const calculateTotalTimelineDuration = useCallback(() => {
    if (selectedAudios.length === 0) {
      return sumOfVideoDuration;
    }

    return Math.max(sumOfVideoDuration, sumOfAudioDuration);
  }, [sumOfVideoDuration, sumOfAudioDuration, selectedAudios]);

  useEffect(() => {
    const newDuration = calculateTotalTimelineDuration();
    setTotalTimelineDuration(newDuration);
  }, [calculateTotalTimelineDuration]);


  useEffect(() => {
    if (!isPlaying && playerRef.current) {
      if (isDraggingHandle) {
        playerRef.current.seekTo(tempTimeUpdate, "seconds");
      } else {
        playerRef.current.seekTo(polygonStartTime, "seconds");
      }
    }
  }, [isDraggingHandle, tempTimeUpdate, polygonStartTime, isPlaying]);

  const pausePlayback = useCallback(() => {
    setIsPlaying(false);
    setToggleButton(false);
    if (audioPlayerRef.current) {
      audioPlayerRef.current.pause();
    }
    setVideoMuted(false);
  }, []);
  const TYPE_Items = [
      { id: 0, type: 'Samples' },
      { id: 1, type: 'My Files' }
   ];
  const handleTabChange = (type) => {
    setActiveTab(type.toLowerCase().replace(' ', ''));
    // Clear search terms when switching tabs
    setSamplesSearchTerm('');
    setMyFilesSearchTerm('');
    // Reset filtered arrays to show all items
    setFilteredDefaultAudios(defaultAudioFiles);
    setFilteredAudioFiles(audioFiles);
  };

  const handleSamplesSearch = (searchValue) => {
    setSamplesSearchTerm(searchValue);
    if (!searchValue.trim()) {
      setFilteredDefaultAudios(defaultAudioFiles);
    } else {
      const filtered = defaultAudioFiles.filter(audio => 
        audio.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredDefaultAudios(filtered);
    }
  };

  const handleMyFilesSearch = (searchValue) => {
    setMyFilesSearchTerm(searchValue);
    if (!searchValue.trim()) {
      setFilteredAudioFiles(audioFiles);
    } else {
      const filtered = audioFiles.filter(audio => 
        audio.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredAudioFiles(filtered);
    }
  };
  const showError = (message, title = "Error") => {
    setErrorModal({ open: true, title, message });
  };
  const closeErrorModal = () => {
    setErrorModal({ open: false, title: "", message: "" });
  };
  useEffect(() => {
    const getCurrentSegment = (time) => {
      let cumulative = 0;
      const index = segments.findIndex((seg) => {
        cumulative += seg.end - seg.start;
        return time <= cumulative;
      });
      let actualStart = 0;
      let offset = 0;

      if (index === -1) {
        setCurrentSegmentIndex(0);
        actualStart = segments[0].start;
        return { ...segments[0], offset, actualStart };
      }

      const previousTotal = cumulative - (segments[index].end - segments[index].start);
      offset = time - previousTotal;
      actualStart = segments[index].start + offset;

      setCurrentSegmentIndex(index);
      return { ...segments[index], offset, actualStart };
    };

    const handleMouseMove = (e) => {
      if (!isDraggingMarker || !timelineTicksContentRef.current) return;
      const rect = timelineTicksContentRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const clampedX = Math.max(0, Math.min(x, rect.width));
      setMarkerPositionPx(clampedX);
      const percent = clampedX / rect.width;
      const newTime = percent * totalTimelineDuration;
      const seg = getCurrentSegment(newTime);
      setPolygonStartTime(newTime);
      if (playerRef.current) {
        playerRef.current.seekTo(seg?.actualStart, "seconds");
      }
    };
    const handleMouseUp = () => {
      if (isDraggingMarker) {
        setIsDraggingMarker(false);
        if (timelineTicksContentRef.current) {
          const rect = timelineTicksContentRef.current.getBoundingClientRect();
          const percent = markerPositionPx / rect.width;
          const newTime = percent * totalTimelineDuration;

          const seg = getCurrentSegment(newTime);

          setPolygonStartTime(newTime);
          setCurrentPlayTime(seg?.actualStart);
          if (playerRef.current) {
            playerRef.current.seekTo(seg?.actualStart, "seconds");
          }
        }
        if (audioPlayerRef.current) {
          audioPlayerRef.current.pause();
        }
      }
      if (isDraggingHandle) {
        setStartTime(tempTimeUpdate);
        if (playerRef.current) {
          playerRef.current.seekTo(tempTimeUpdate, "seconds");
        }
        setIsDraggingHandle(false);
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDraggingMarker, duration, startTime, endTime, currentPlayTime, markerPositionPx, isDraggingHandle, tempTimeUpdate]);

  useEffect(() => {
    if (selectedAudios.length > 0) {
      setTimeout(() => {
        setTimelineReady(true);
      }, 0);
    } else {
      setTimelineReady(false);
    }
  }, [selectedAudios]);

  const captureState = () => {
    return {
      selectedAudios: [...selectedAudios],
      panOffsets: { ...panOffsets },
      startTime,
      endTime,
      displayDuration,
      segments: JSON.parse(JSON.stringify(segments)),
      selectedSegment,
    };
  };

  const isEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  const pushToHistory = (newState) => {
    if (historyIndex < history.length - 1) {
      setHistory(history.slice(0, historyIndex + 1));
      setFuture([]);
    }

    setHistory((prev) => {
      const newHistory = [...prev, newState];
      setHistoryIndex(newHistory.length - 1);
      return newHistory;
    });
  };

  const handleToggle = (audio) => {
    if (currentlyPlayingAudio && currentlyPlayingAudio.id === audio.id) {
      audioPlayerRef.current.pause();
      setCurrentlyPlayingAudio(null);
      setPlayState(false);
    } else {
      if (currentlyPlayingAudio) {
        audioPlayerRef.current.pause();
        audioPlayerRef.current.currentTime = 0;
      }
      audioPlayerRef.current.src = audio.url;
      audioPlayerRef.current
        .play()
        .then(() => {
          setCurrentlyPlayingAudio(audio);
          setPlayState(true);
        })
        .catch((error) => {
          console.error("Error playing audio:", error);
        });
    }
  };

  const undo = () => {
    pausePlayback();
    if (historyIndex <= 0) return;

    const previousState = history[historyIndex - 1];
    setFuture([captureState(), ...future]);
    applyState(previousState);
    setHistoryIndex(historyIndex - 1);
  };

  const redo = () => {
    pausePlayback();
    if (future.length === 0) return;
    const nextState = future[0];
    setHistory([...history, captureState()]);
    applyState(nextState);
    setFuture(future.slice(1));
    setHistoryIndex(historyIndex + 1);
  };

  const applyState = (state) => {
    setSelectedAudios(state.selectedAudios);
    setPanOffsets(state.panOffsets);
    setStartTime(state.startTime);
    setEndTime(state.endTime);
    setDisplayDuration(state.displayDuration);
    setSegments(state.segments || []);
    setSelectedSegment(state.selectedSegment || null);
  };

  const handleCopyAudio = () => {
    pausePlayback();
    if (selectedAudioIndex === null || selectedAudioIndex >= selectedAudios.length) return;
    const audioToCopy = selectedAudios[selectedAudioIndex];
    const copiedAudio = {
      ...audioToCopy,
      id: `${audioToCopy.id}-copy-${Date.now()}`,
      name: `${audioToCopy.name} (copy)`,
      audioKey: audioToCopy.audioKey,
      audioStartTime: audioToCopy.audioStartTime,
      audioEndTime: audioToCopy.audioEndTime,
      originalStartTime: audioToCopy.originalStartTime !== undefined ? audioToCopy.originalStartTime : audioToCopy.audioStartTime,
      originalEndTime: audioToCopy.originalEndTime !== undefined ? audioToCopy.originalEndTime : audioToCopy.audioEndTime,
      duration: audioToCopy.duration,
      url: audioToCopy.url,
      copy: true,
      overlayAudioVolume: audioToCopy.overlayAudioVolume || 1,
    };
    setCopiedAudio(copiedAudio);
    setShowPasteIcon(true);
  };

  const handleDeleteAudio = () => {
    pausePlayback();
    if (selectedAudioIndex === null) return;
    setSelectedAudios((prev) => {
      const newAudios = prev.filter((_, i) => i !== selectedAudioIndex);
      pushToHistory(captureState());
      return newAudios;
    });
    setPanOffsets((prev) => {
      const newPanOffsets = { ...prev };
      delete newPanOffsets[selectedAudioIndex];
      Object.keys(newPanOffsets).forEach((key) => {
        const index = parseInt(key);
        if (index > selectedAudioIndex) {
          newPanOffsets[index - 1] = newPanOffsets[index];
          delete newPanOffsets[index];
        }
      });
      return newPanOffsets;
    });
    setSelectedAudioIndex(null);
  };
  const handlePasteAudio = () => {
    pausePlayback();
    if (!copiedAudio) return;
    const copiedAudioKey = copiedAudio.audioKey || copiedAudio.id;
    
    const clipsOfSameAudio = selectedAudios.filter((a) => {
      const aKey = a.audioKey || a.id;
      return aKey === copiedAudioKey;
    });
    
    let startTimeInVideo = 0;
    if (clipsOfSameAudio.length > 0) {
      const lastClipOfSameAudio = clipsOfSameAudio.reduce((latest, current) => {
        const latestEnd = latest.audioEndInTimeINVideo || 0;
        const currentEnd = current.audioEndInTimeINVideo || 0;
        return currentEnd > latestEnd ? current : latest;
      });
      startTimeInVideo = lastClipOfSameAudio.audioEndInTimeINVideo || 0;
    }
    
    const copiedAudioDuration = copiedAudio.audioEndTime - copiedAudio.audioStartTime;
    const newAudioClip = {
      id: `${copiedAudio.id}-copy-${Date.now()}`,
      name: `${copiedAudio.name.replace(/ \(copy\)$/, "")} (copy)`,
      audioStartTime: copiedAudio?.audioStartTime,
      audioEndTime: copiedAudio?.audioEndTime,
      audioKey: copiedAudio?.audioKey,
      originalStartTime: copiedAudio?.originalStartTime,
      originalEndTime: copiedAudio?.originalEndTime,
      duration: copiedAudio?.duration,
      audioStartInTimeINVideo: startTimeInVideo,
      audioEndInTimeINVideo: startTimeInVideo + copiedAudioDuration,
      copy: true,
      url: copiedAudio?.url,
      overlayAudioVolume: copiedAudio?.overlayAudioVolume || 1,
    };
    const newIndex = selectedAudios.length;
    setSelectedAudios((prev) => [...prev, newAudioClip]);
    setPanOffsets((prev) => ({
      ...prev,
      [newIndex]: 0,
    }));
    setIsWaveformLoading(true);
    setWaveformLoadingStates((prev) => ({
      ...prev,
      [newAudioClip.id]: true,
    }));
    setCopiedAudio(null);
    setShowPasteIcon(false);
    setSelectedAudioIndex(newIndex);
    pushToHistory(captureState());
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      const isModifierKey = e.ctrlKey || e.metaKey;
      
      if (e.key === " " || e.code === "Space") {
        if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
          return;
        }
        e.preventDefault();
        toggleAudioPlay();
      } else if (isModifierKey && e.key === "z") {
        e.preventDefault();
        undo();
      } else if (isModifierKey && e.key === "y") {
        e.preventDefault();
        redo();
      } else if (isModifierKey && e.key === "c") {
        e.preventDefault();
        if (selectedAudioIndex !== null) {
          handleCopyAudio();
        } else if (isVideoSelected) {
          handleCopyVideo();
        }
      } else if (isModifierKey && e.key === "v") {
        e.preventDefault();
        if (copiedAudio) {
          handlePasteAudio();
        } else if (copiedVideoSegment) {
          handlePasteVideo();
        }
      } else if (e.key === "Delete") {
        e.preventDefault();
        if (selectedAudioIndex !== null) {
          handleDeleteAudio();
        } else if (selectedSegment !== null) {
          handleDeleteVideo();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [undo, redo, handleCopyAudio, handlePasteAudio, selectedAudioIndex, copiedAudio, copiedVideoSegment, isVideoSelected, selectedSegment, showPasteIcon, toggleButton]);

  const onClickAudio = (index) => {
    if (isWaveformLoading) {
      return;
    }
    if (index === selectedAudioIndex) {
      setSelectedAudioIndex(null);
      setShowPasteIcon(false);
    } else {
      setSelectedAudioIndex(index);
      setShowPasteIcon(false);
      const currentVolume = selectedAudios[index]?.overlayAudioVolume;
      if (currentVolume !== undefined) {
        setAudioVolume(currentVolume);
      }
    }
  };

  const animateTimelineMarker = () => {
    const elapsedMs = Date.now() - playStartTimestampRef.current;
    const elapsedSeconds = elapsedMs / 1000;
    const newTime = startTime + elapsedSeconds;
    if (newTime >= endTime) {
      cancelAnimationFrame(animationRef.current);
      setCurrentPlayTime(startTime);
      setToggleButton(false);
      return;
    }
    setCurrentPlayTime(newTime);
    animationRef.current = requestAnimationFrame(animateTimelineMarker);
  };
  const extractFrames = useCallback(async () => {
    if (!showDetails?.ShowURL) return;
    setFramesLoading(true);
    setFrames([]);
    try {
      const inputBody = {
        object_key: mp4File.Key,
        bucketName: bucketName,
      };
      const response = await fetchVideoFrames(inputBody);
      if (response.status === 200 && response.data.Data) {
        setFrames(response.data.Data);
      } else {
        console.error("Failed to fetch frames: Invalid response format.");
      }
    } catch (error) {
      console.error("Error fetching frames from backend API:", error);
    } finally {
      setFramesLoading(false);
    }
  }, [showDetails?.ShowURL, mp4File, bucketName]);

  useEffect(() => {
    if (duration > 0) {
      extractFrames();
    }
  }, [duration, extractFrames]);

  useEffect(() => {
    const fetchDefaultAudios = async () => {
      try {
        const audioFiles = await getAudioFiles();
        const audioPromises = audioFiles.map(async (audio) => {
          const duration = await getAudioDuration(audio.audioURL);
          return {
            id: audio.audioKey,
            audioKey: audio.audioKey,
            name: audio.audioFileName,
            url: audio.audioURL,
            isDefault: true,
            duration: duration,
          };
        });
        const formattedAudios = await Promise.all(audioPromises);
        setDefaultAudioFiles(formattedAudios);
        setFilteredDefaultAudios(formattedAudios);
      } catch (error) {
        console.error("Error fetching default audio files:", error);
      }
    };

    const fetchMyAudioFiles = async () => {
      try {
        const response = await getMyAudioFiles(roomID);
        console.log('fetchMyAudioFiles response:', response);
        
        const audioData = Array.isArray(response) ? response : response?.Data;
        
        if (audioData && audioData.length > 0) {
          const audioPromises = audioData.map(async (audio) => {
            const duration = audio.Duration || await getAudioDuration(audio.AudioUrl);
            return {
              id: audio.AudioKey,
              audioKey: audio.AudioKey,
              audioID: audio.AudioID,
              name: audio.FileName,
              url: audio.AudioUrl,
              isDefault: false,
              duration: duration,
            };
          });
          const formattedAudios = await Promise.all(audioPromises);
          console.log('Formatted user audio files:', formattedAudios);
          setAudioFiles(formattedAudios);
          setFilteredAudioFiles(formattedAudios);
        }
      } catch (error) {
        console.error("Error fetching user audio files:", error);
      }
    };

    fetchDefaultAudios();
    if (roomID) {
      fetchMyAudioFiles();
    }
  }, [roomID]);
  const getAudioDuration = (url) => {
    return new Promise((resolve) => {
      const audio = new Audio(url);
      audio.preload = "metadata";
      const resolveDuration = () => {
        if (audio.duration > 0) {
          resolve(audio.duration);
        } else {
          resolve(0);
        }
      };
      const handleLoadedMetadata = () => {
        if (audio.duration > 0) {
          resolve(audio.duration);
        } else {
          audio.addEventListener("durationchange", resolveDuration, {
            once: true,
          });
        }
      };
      const handleError = () => {
        console.error("Error loading audio for duration check");
        resolve(0);
      };

      audio.onloadedmetadata = handleLoadedMetadata;
      audio.onerror = handleError;
      audio.load();
    });
  };

  const handleSelectDefaultAudio = async (audio) => {
    if (isWaveformLoading) {
      return;
    }

    setIsWaveformLoading(true);
    const audioDuration = await getAudioDuration(audio.url);
    const audioWithDuration = {
      ...audio,
      duration: audioDuration,
    };
    const audioKey = audio.audioKey || audio.id;
    const isSelected = selectedAudios.some((a) => {
      const aKey = a.audioKey || a.id;
      return aKey === audioKey || a.id.startsWith(audio.id);
    });
    
    if (isSelected) {
      setSelectedAudios((prev) => prev.filter((a) => {
        const aKey = a.audioKey || a.id;
        return !(aKey === audioKey || a.id.startsWith(audio.id));
      }));
      // Update pan offsets to remove gaps
      setPanOffsets((prev) => {
        const newOffsets = {};
        let offsetIndex = 0;
        Object.keys(prev).forEach(key => {
          const keyIndex = Number.parseInt(key);
          const audioAtIndex = selectedAudios[keyIndex];
          if (audioAtIndex) {
            const aKey = audioAtIndex.audioKey || audioAtIndex.id;
            if (aKey !== audioKey && !audioAtIndex.id.startsWith(audio.id)) {
              newOffsets[offsetIndex] = prev[key];
              offsetIndex++;
            }
          }
        });
        return newOffsets;
      });
      setIsWaveformLoading(false);
    } else {
      const existingClipsForAudio = selectedAudios.filter((a) => {
        const aKey = a.audioKey || a.id;
        return aKey === audioKey;
      });
      
      let startTimeInVideo = 0;
      if (existingClipsForAudio.length > 0) {
        const lastClipOfSameAudio = existingClipsForAudio.reduce((latest, current) => {
          const latestEnd = latest.audioEndInTimeINVideo || 0;
          const currentEnd = current.audioEndInTimeINVideo || 0;
          return currentEnd > latestEnd ? current : latest;
        });
        startTimeInVideo = lastClipOfSameAudio.audioEndInTimeINVideo || 0;
      }
      
      const newAudio = {
        ...audioWithDuration,
        audioStartTime: 0,
        audioEndTime: audioDuration,
        audioStartInTimeINVideo: startTimeInVideo,
        audioEndInTimeINVideo: startTimeInVideo + audioDuration,
        overlayAudioVolume: 1,
      };
      setSelectedAudios((prev) => [...prev, newAudio]);
      setPanOffsets((prev) => ({ ...prev, [selectedAudios.length]: 0 }));
      setWaveformLoadingStates((prev) => ({
        ...prev,
        [newAudio.id]: true,
      }));

      setTimeout(() => updateAudioTimeInVideo(), 0);
    }
    pushToHistory(captureState());
  };

  const handleDragStart = (type, x) => {
    pausePlayback();
    setIsDraggingOperation(true);
    setInitialDragState(captureState());
    setDragging(type);
  };

  const handleDragEnd = () => {
    if (isDraggingOperation) {
      const currentState = captureState();
      if (!isEqual(initialDragState, currentState)) {
        pushToHistory(initialDragState);
        pushToHistory(currentState);
      }
      setIsDraggingOperation(false);
      setInitialDragState(null);
    }
    if (dragging && dragging.startsWith("audio-pan-")) {
      const index = Number.parseInt(dragging.split("-")[2]);
      const audio = selectedAudios[index];
      if (audio) {
        const audioTimelineContainers = document.querySelectorAll('.audio-timeline-container');
        let timeline = null;
        
        timeline = audioTimelineContainers[0] || audioTimelineRef.current;
        
        if (timeline) {
          const rect = timeline.getBoundingClientRect();
          const width = rect.width || 1;
          const currentOffsetPx = panOffsets[index] || 0;
          const baseStartPx = ((audio.audioStartInTimeINVideo || 0) / displayDuration) * width;
          const visualStartPx = baseStartPx + currentOffsetPx;
          const newStartIn = (visualStartPx / width) * displayDuration;
          const trimmedLen = Math.max(0, audio.audioEndTime - audio.audioStartTime);
          setSelectedAudios((prev) => {
            const updated = [...prev];
            if (updated[index]) {
              updated[index] = {
                ...updated[index],
                audioStartInTimeINVideo: newStartIn,
                audioEndInTimeINVideo: newStartIn + trimmedLen,
              };
            }
            return updated;
          });
          setPanOffsets((prev) => {
            const next = { ...prev };
            next[index] = 0;
            return next;
          });
        }
      }
    }
    if (dragging === "video-pan" && videoPanStartTime !== null) {
      const timeline = videoTimelineRef.current;
      if (timeline) {
        const timelineRect = timeline.getBoundingClientRect();
        const timelineWidth = timelineRect.width;
        const offsetPercent = videoPanOffset / timelineWidth;
        const segmentDuration = endTime - startTime;
        let newStart = videoPanStartTime + offsetPercent * duration;
        newStart = Math.max(0, Math.min(newStart, duration - segmentDuration));
        setStartTime(newStart);
        setEndTime(newStart + segmentDuration);
      }
      setVideoPanOffset(0);
      setVideoPanStartTime(null);
    }
    setDragging(null);
  };

  const getCollisionBoundaries = (currentIndex, proposedVisualStartPx, timelineWidth) => {
    const currentAudio = selectedAudios[currentIndex];
    if (!currentAudio) return { minPx: 0, maxPx: timelineWidth };
    const currentAudioKey = currentAudio.audioKey || currentAudio.id;
    const currentDurationSec = Math.max(0, currentAudio.audioEndTime - currentAudio.audioStartTime);
    const currentWidthPx = (currentDurationSec / displayDuration) * timelineWidth;
    let minPx = 0;
    let maxPx = timelineWidth - currentWidthPx;
    selectedAudios.forEach((audio, index) => {
      if (index === currentIndex) return;
      const otherAudioKey = audio.audioKey || audio.id;
      if (otherAudioKey !== currentAudioKey) return;
      
      const otherDurationSec = Math.max(0, audio.audioEndTime - audio.audioStartTime);
      const otherWidthPx = (otherDurationSec / displayDuration) * timelineWidth;
      const otherStartPx = ((audio.audioStartInTimeINVideo || 0) / displayDuration) * timelineWidth + (panOffsets[index] || 0);
      const otherEndPx = otherStartPx + otherWidthPx;
      const proposedEndPx = proposedVisualStartPx + currentWidthPx;
      if (proposedVisualStartPx < otherEndPx && proposedEndPx > otherStartPx) {
        if (proposedVisualStartPx < otherStartPx) {
          const newMax = otherStartPx - currentWidthPx;
          maxPx = Math.min(maxPx, newMax);
        } else {
          const newMin = otherEndPx;
          minPx = Math.max(minPx, newMin);
        }
      }
    });
    return { minPx, maxPx };
  };

  const checkAudioHandleCollision = (currentIndex, isStartHandle, proposedTime, timelineWidth) => {
    const currentAudio = selectedAudios[currentIndex];
    if (!currentAudio) return false;
    const currentAudioKey = currentAudio.audioKey || currentAudio.id;
    const tempAudio = {
      ...currentAudio,
      audioStartTime: isStartHandle ? proposedTime : currentAudio.audioStartTime,
      audioEndTime: isStartHandle ? currentAudio.audioEndTime : proposedTime,
    };
    const tempWidthPx = (Math.max(0, tempAudio.audioEndTime - tempAudio.audioStartTime) / displayDuration) * timelineWidth;
    for (let index = 0; index < selectedAudios.length; index++) {
      if (index === currentIndex) continue;
      const audio = selectedAudios[index];
      const otherAudioKey = audio.audioKey || audio.id;
      if (otherAudioKey !== currentAudioKey) continue;
      
      const otherStartPx = ((audio.audioStartInTimeINVideo || 0) / displayDuration) * timelineWidth + (panOffsets[index] || 0);
      const otherWidthPx = (Math.max(0, audio.audioEndTime - audio.audioStartTime) / displayDuration) * timelineWidth;
      const otherEndPx = otherStartPx + otherWidthPx;
      const currentStartPx = ((currentAudio.audioStartInTimeINVideo || 0) / displayDuration) * timelineWidth + (panOffsets[currentIndex] || 0);
      const currentEndPx = currentStartPx + tempWidthPx;
      if (currentEndPx > otherStartPx && currentStartPx < otherEndPx) {
        return true;
      }
    }

    return false;
  };

  const handleTimelineDrag = (e) => {
    if (!dragging || !duration) return;

    switch (true) {
      case dragging.startsWith("audio-start-"):
      case dragging.startsWith("audio-end-"):
        handleAudioTrimDrag(e);
        break;
      case dragging.startsWith("audio-pan-"):
        handleAudioPanDrag(e);
        break;
      default:
        break;
    }
  };

  const findAudioTimeline = (e) => {
    const audioTimelineContainers = document.querySelectorAll('.audio-timeline-container');
    
    for (const container of audioTimelineContainers) {
      const clips = container.querySelectorAll('.audio-clip');
      for (const clip of clips) {
        if (clip.contains(e.target) || clip === e.target) {
          return container;
        }
      }
    }
    
    return audioTimelineContainers[0] || audioTimelineRef.current;
  };

  const getMinAudioGapPercent = (duration) => {
    if (duration < 30) return 0.15;
    if (duration < 60) return 0.05;
    if (duration < 120) return 0.035;
    if (duration < 180) return 0.02;
    return 0.01;
  };

  const handleAudioTrimDrag = (e) => {
    const index = parseInt(dragging.split("-")[2]);
    const audio = selectedAudios[index];
    if (!audio) return;
    
    const timeline = findAudioTimeline(e);
    if (!timeline) return;
    
    const timelineRect = timeline.getBoundingClientRect();
    const position = (e.clientX - timelineRect.left) / timelineRect.width;
    const minGap = audio.duration * getMinAudioGapPercent(audio.duration);
    const isStartHandle = dragging.startsWith("audio-start-");
    const proposedTime = calculateProposedTime(position, displayDuration, isStartHandle, audio, minGap);

    if (proposedTime > audio?.duration) return;
    if (checkAudioHandleCollision(index, isStartHandle, proposedTime, timelineRect.width)) return;
    
    updateAudioTime(index, isStartHandle, proposedTime);
    updateAudioPlayback(position, displayDuration, isStartHandle, audio);
  };

  const calculateProposedTime = (position, displayDuration, isStartHandle, audio, minGap) => {
    if (isStartHandle) {
      const timelineTime = position * displayDuration;
      const audioTimelineStart = audio.audioStartInTimeINVideo || 0;
      const newStartTime = audio.audioStartTime + (timelineTime - audioTimelineStart);
      return Math.max(0, Math.min(newStartTime, audio.audioEndTime - minGap));
    }
    const timelineTime = position * displayDuration;
    const audioTimelineStart = audio.audioStartInTimeINVideo || 0;
    const newEndTime = audio.audioStartTime + (timelineTime - audioTimelineStart);
    return Math.min(displayDuration, Math.max(newEndTime, audio.audioStartTime + minGap));
  };

  const updateAudioTime = (index, isStartHandle, proposedTime) => {
    setSelectedAudios((prev) => {
      const updated = [...prev];
      const currentAudio = updated[index];

      if (isStartHandle) {
        const newOriginalStartTime = currentAudio.originalStartTime !== undefined ? currentAudio.originalStartTime + (proposedTime - currentAudio.audioStartTime) : undefined;

        updated[index] = {
          ...currentAudio,
          audioStartTime: proposedTime,
          ...(currentAudio.originalStartTime !== undefined && {
            originalStartTime: newOriginalStartTime,
          }),
        };
      } else {
        const newOriginalEndTime = currentAudio.originalEndTime !== undefined ? currentAudio.originalEndTime + (proposedTime - currentAudio.audioEndTime) : undefined;

        updated[index] = {
          ...currentAudio,
          audioEndTime: proposedTime,
          ...(currentAudio.originalEndTime !== undefined && {
            originalEndTime: newOriginalEndTime,
          }),
        };
      }
      const trimmedLen = Math.max(0, updated[index].audioEndTime - updated[index].audioStartTime);
      const startInVideo = updated[index].audioStartInTimeINVideo || 0;
      let newStartInVideo = startInVideo;
      if (isStartHandle) {
        const startTimeChange = proposedTime - currentAudio.audioStartTime;
        newStartInVideo = startInVideo + startTimeChange;
      }

      updated[index] = {
        ...updated[index],
        audioStartInTimeINVideo: newStartInVideo,
        audioEndInTimeINVideo: newStartInVideo + trimmedLen,
      };

      return updated;
    });

    setTimeout(() => updateAudioTimeInVideo(), 0);
  };

  const updateAudioPlayback = (position, displayDuration, isStartHandle, audio) => {
    if (!audioRef.current) return;
    const seekTime = Math.max(0, Math.min(position * displayDuration, isStartHandle ? audio.audioEndTime - 0.1 : audio.duration));

    audioRef.current.currentTime = seekTime;
    setIsAudioPlaying(false);
  };

  const handleAudioPanDrag = (e) => {
    const index = parseInt(dragging.split("-")[2]);
    const audio = selectedAudios[index];
    if (!audio) return;
    
    const audioTimelineContainers = document.querySelectorAll('.audio-timeline-container');
    let timeline = null;
    
    for (const container of audioTimelineContainers) {
      const clips = container.querySelectorAll('.audio-clip');
      for (const clip of clips) {
        if (clip.contains(e.target) || clip === e.target) {
          timeline = container;
          break;
        }
      }
      if (timeline) break;
    }
    
    if (!timeline) timeline = audioTimelineRef.current;
    if (!timeline) return;    
    const timelineRect = timeline.getBoundingClientRect();
    const timelineWidth = timelineRect.width;
    const startOffsetPx = ((audio.audioStartInTimeINVideo || 0) / displayDuration) * timelineWidth;
    const deltaX = e.clientX - panStartX;
    const currentOffset = panOffsets[index] || 0;
    const proposedOffset = currentOffset + deltaX;
    const proposedVisualStart = proposedOffset + startOffsetPx;
    const { minPx, maxPx } = getCollisionBoundaries(index, proposedVisualStart, timelineWidth);
    const clampedVisualStart = Math.max(minPx, Math.min(maxPx, proposedVisualStart));
    const newPanOffset = clampedVisualStart - startOffsetPx;

    setPanOffsets((prev) => ({
      ...prev,
      [index]: newPanOffset,
    }));

    setPanStartX(e.clientX);
  };

  const handleSelectAudio = (audio) => {
    if (isWaveformLoading) {
      return;
    }

    setIsWaveformLoading(true);
    const audioKey = audio.audioKey || audio.id;
    const isSelected = selectedAudios.some((a) => {
      const aKey = a.audioKey || a.id;
      return aKey === audioKey || a.id.startsWith(audio.id);
    });
    
    if (isSelected) {
      setSelectedAudios((prev) => prev.filter((a) => {
        const aKey = a.audioKey || a.id;
        return !(aKey === audioKey || a.id.startsWith(`${audio.id}-copy`));
      }));
      setIsWaveformLoading(false);
    } else {
      const existingClipsForAudio = selectedAudios.filter((a) => {
        const aKey = a.audioKey || a.id;
        return aKey === audioKey;
      });
      let startTimeInVideo = 0;
      if (existingClipsForAudio.length > 0) {
        const lastClipOfSameAudio = existingClipsForAudio.reduce((latest, current) => {
          const latestEnd = latest.audioEndInTimeINVideo || 0;
          const currentEnd = current.audioEndInTimeINVideo || 0;
          return currentEnd > latestEnd ? current : latest;
        });
        startTimeInVideo = lastClipOfSameAudio.audioEndInTimeINVideo || 0;
      }
      
      const newAudio = {
        ...audio,
        audioStartTime: 0,
        audioEndTime: audio.duration,
        audioStartInTimeINVideo: startTimeInVideo,
        audioEndInTimeINVideo: startTimeInVideo + audio.duration,
        overlayAudioVolume: 1,
      };

      setSelectedAudios((prev) => [...prev, newAudio]);
      setPanOffsets((prev) => ({ ...prev, [selectedAudios.length]: 0 }));

      // Set individual loading state for this audio
      setWaveformLoadingStates((prev) => ({
        ...prev,
        [newAudio.id]: true,
      }));

      setTimeout(() => updateAudioTimeInVideo(), 0);
    }
    pushToHistory(captureState());
  };

  const handleDeleteMyAudio = async (audio) => {
    try {
      await deleteExternalAudio(roomID, audio.audioID);
      setAudioFiles((prev) => prev.filter((a) => a.audioID !== audio.audioID));
      setFilteredAudioFiles((prev) => prev.filter((a) => a.audioID !== audio.audioID));
    } catch (error) {
      console.error('Error deleting audio:', error);
      showError('Failed to delete audio file');
    }
  };
  const handleWaveformReady = (audioId) => {
    setWaveformLoadingStates((prev) => {
      const newState = {
        ...prev,
        [audioId]: false,
      };
      const allLoaded = Object.values(newState).every((loading) => !loading);
      if (allLoaded) {
        setIsWaveformLoading(false);
      }

      return newState;
    });
  };

  const toggleAudioPlay = () => {
    setToggleButton((prev) => {
      const next = !prev;
      setIsPlaying(next);
      if (!next) {
        if (audioPlayerRef.current) {
          audioPlayerRef.current.pause();
        }
        setVideoMuted(false);
        setIsMarkerFollowingPlayback(false);
      } else {
        setIsMarkerFollowingPlayback(true);
        let found = false;
        selectedAudios.forEach((audio) => {
          const startIn = audio.audioStartInTimeINVideo || 0;
          const endIn = audio.audioEndInTimeINVideo || startIn + Math.max(0, audio.audioEndTime - audio.audioStartTime);
          if (currentPlayTime >= startIn && currentPlayTime < endIn) {
            found = true;
          }
        });
        setVideoMuted(found);
        if (!found && audioPlayerRef.current) {
          audioPlayerRef.current.pause();
          audioPlayerRef.current.currentTime = 0;
        }
      }
      return next;
    });
  };

  useEffect(() => {
    if (!isAudioPlaying || !audioRef.current) return;
    const interval = setInterval(() => {
      const currentTime = audioRef.current.currentTime;
      if (currentTime >= audioEndTime) {
        audioRef.current.pause();
        audioRef.current.currentTime = audioStartTime;
        setIsAudioPlaying(false);
      } else {
        setAudioStartTime(currentTime);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isAudioPlaying, audioStartTime, audioEndTime]);

  const onDuration = (duration) => {
    setDuration(duration);
    setEndTime(duration);
  };

  const getCurrentSegmentVolume = (currentTime) => {
    const currentSegment = segments[currentSegmentIndex];
    if (!currentSegment) return videoAudioVolume;
    return segmentVolumes[currentSegment.id] || currentSegment.videoAudioVolume || videoAudioVolume;
  };

  const ensureCorrectSegment = (currentTime) => {
    const correctSegmentIndex = segments.findIndex(segment => 
      currentTime >= segment.start && currentTime < segment.end
    );
    
    if (correctSegmentIndex !== -1 && correctSegmentIndex !== currentSegmentIndex && !isDraggingMarker && !isDraggingHandle) {
      setCurrentSegmentIndex(correctSegmentIndex);
    }
  };

  const handleTrimBounds = (currentTime) => {
    const { start: trimStart, end: trimEnd } = getTrimBounds();
    
    if (currentTime < trimStart - 0.05) {
      if (playerRef.current) playerRef.current.seekTo(trimStart, "seconds");
      return true;
    }
    
    if (currentTime > trimEnd + 0.05) {
      if (playerRef.current) playerRef.current.seekTo(trimStart, "seconds");
      setIsPlaying(false);
      setToggleButton(false);
      return true;
    }
    
    return false;
  };

  const updateVideoVolume = () => {
    if (!playerRef.current?.getInternalPlayer) return;
    
    const internalPlayer = playerRef.current.getInternalPlayer();
    if (internalPlayer?.volume === undefined) return;
    
    const targetVolume = selectedSegment && segmentVolumes[selectedSegment.id] !== undefined 
      ? segmentVolumes[selectedSegment.id] 
      : videoAudioVolume;
    const finalVolume = isVideoMuted ? 0 : targetVolume;
    
    if (internalPlayer.volume !== finalVolume) {
      internalPlayer.volume = finalVolume;
    }
  };

  const handleSegmentBounds = (currentTime, currentSegment) => {
    const { start: trimStart, end: trimEnd } = getTrimBounds();
    const segmentStart = Math.max(currentSegment.start, trimStart);
    const segmentEnd = Math.min(currentSegment.end, trimEnd);
    
    if (shouldTransitionToNext(currentTime, segmentEnd)) {
      handleSegmentTransition();
    }
    
    if (isOutsideSegment(currentTime, { start: segmentStart, end: segmentEnd })) {
      playerRef.current.seekTo(segmentStart, "seconds");
    }
  };

  const onProgress = (state) => {
    const currentTime = state.playedSeconds;

    if (handleTrimBounds(currentTime)) return;
    if (!isPlaying) return handlePauseState();

    ensureCorrectSegment(currentTime);
    
    const currentSegment = segments[currentSegmentIndex];
    if (!currentSegment) return seekToFirstSegment();

    updateVideoVolume();

    const virtualTime = computeVirtualTime(currentTime, currentSegment);
    updateTimelineProgress(virtualTime);

    if (!isDraggingMarker && !isDraggingHandle) {
      setPolygonStartTime(virtualTime);
    }

    handleAudioPlayback(virtualTime);
    handleSegmentBounds(currentTime, currentSegment);
  };

  const handlePauseState = () => {
    if (audioPlayerRef.current) audioPlayerRef.current.pause();
    setVideoMuted(false);
    setIsMarkerFollowingPlayback(false);
  };

  const seekToFirstSegment = () => {
    const { start: trimStart } = getTrimBounds();
    const firstSegment = segments[0] || { start: trimStart };
    setCurrentSegmentIndex(0);
    playerRef.current.seekTo(Math.max(firstSegment.start, trimStart), "seconds");
  };

  const computeVirtualTime = (currentTime, currentSegment) => {
    const segmentProgress = currentTime - currentSegment.start;
    return segments.slice(0, currentSegmentIndex).reduce((sum, seg) => sum + (seg.end - seg.start), 0) + segmentProgress;
  };

  const updateTimelineProgress = (virtualTime) => {
    if (isMarkerFollowingPlayback && timelineTicksContentRef.current) {
      const rect = timelineTicksContentRef.current.getBoundingClientRect();
      const percent = virtualTime / totalTimelineDuration;
      const px = Math.max(0, Math.min(percent, 1)) * rect.width;
      setMarkerPositionPx(px);
      setCurrentPlayTime(virtualTime);
    }
  };

  const shouldTransitionToNext = (currentTime, segmentEnd) => {
    return Math.ceil(currentTime) >= segmentEnd;
  };

  const resetToFirstSegment = () => {
    setIsPlaying(false);
    setCurrentSegmentIndex(0);
    playerRef.current.seekTo(segments[0].start, "seconds");
    if (audioPlayerRef.current) audioPlayerRef.current.pause();
    setVideoMuted(false);
  };

  const transitionToNextSegment = (nextIndex) => {
    setCurrentSegmentIndex(nextIndex);
    playerRef.current.seekTo(segments[nextIndex].start, "seconds");
    
    const nextSegment = segments[nextIndex];
    const internalPlayer = playerRef.current?.getInternalPlayer?.();
    
    if (nextSegment && internalPlayer?.volume !== undefined) {
      const nextSegmentVolume = segmentVolumes[nextSegment.id] ?? videoAudioVolume;
      internalPlayer.volume = isVideoMuted ? 0 : nextSegmentVolume;
    }
  };

  const handleSegmentTransition = () => {
    const nextIndex = (currentSegmentIndex + 1) % segments.length;
    
    if (nextIndex === 0) {
      resetToFirstSegment();
    } else {
      transitionToNextSegment(nextIndex);
    }
  };

  const isOutsideSegment = (currentTime, segment) => {
    return currentTime < segment.start - 0.5 || currentTime > segment.end + 0.5;
  };

  const handleAudioPlayback = (virtualTime) => {
    let found = false;

    console.log("selectedAudios--", selectedAudios);

    selectedAudios.forEach((audio, idx) => {
      const startIn = audio.audioStartInTimeINVideo || 0;
      const endIn = audio.audioEndInTimeINVideo || startIn + Math.max(0, audio.audioEndTime - audio.audioStartTime);

      if (virtualTime >= startIn && virtualTime < endIn) {
        if (playingAudioIndex !== idx || audioPlayerRef.current?.paused) {
          if (audioPlayerRef.current) {
            audioPlayerRef.current.src = audio.url;
            const currentAudioVolume = selectedAudioIndex === idx ? audioVolume : (audio.overlayAudioVolume || 1);
            audioPlayerRef.current.volume = mutedAudioKeys.has(audio.audioKey || audio.id) ? 0 : currentAudioVolume;
            audioPlayerRef.current.currentTime = virtualTime - startIn + (audio.audioStartTime || 0);
            audioPlayerRef.current.play().catch(e => console.error('Audio play failed:', e));
          }
          setPlayingAudioIndex(idx);
        }
        setVideoMuted(true);
        found = true;
      }
    });

    if (!found) {
      if (playingAudioIndex !== null) {
        if (audioPlayerRef.current) audioPlayerRef.current.pause();
        setPlayingAudioIndex(null);
      }
      setVideoMuted(false);
    }
  };

  const onSeek = (seekTime) => {
    const { start, end } = getTrimBounds();
    const clamped = Math.max(start, Math.min(end, seekTime));
    if (clamped !== seekTime && playerRef.current) {
      playerRef.current.seekTo(clamped, "seconds");
    }
    setCurrentPlayTime(clamped);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    processAudioFiles(e.dataTransfer.files);
  };

  const handleCancel = () => navigate(`/shows/details/${showId}`);
  const handleImportAudioClick = () => fileInputRef.current.click();
  const isDuplicateAudio = (newFile, existingFiles) => {
    return existingFiles.some((existingFile) => existingFile.name === newFile.name && existingFile.size === newFile.size);
  };

  const processAudioFiles = (files) => {
    const validAudioFiles = filterValidAudioFiles(files);
    if (validAudioFiles.length === 0) {
      showError("Please select or drop valid audio files only.");
      return;
    }

    const allExistingFiles = getAllExistingFiles();
    const newFiles = filterNewFiles(validAudioFiles, allExistingFiles);

    if (newFiles.length === 0) {
      showError("All selected files are duplicates and won't be added.");
      return;
    }

    if (newFiles.length < validAudioFiles.length) {
      showError(`Skipped ${validAudioFiles.length - newFiles.length} duplicate file(s).`);
    }

    handleAudioProcessing(newFiles);
  };

  const filterValidAudioFiles = (files) => {
    return Array.from(files).filter((file) => file.type.startsWith("audio/"));
  };

  const getAllExistingFiles = () => {
    return [
      ...defaultAudioFiles.map((a) => ({ name: a.name, size: a.duration })),
      ...audioFiles.map((a) => ({
        name: a.name,
        size: a.file?.size || a.duration,
      })),
    ];
  };

  const filterNewFiles = (validFiles, existingFiles) => {
    return validFiles.filter((file) => !isDuplicateAudio(file, existingFiles));
  };

  const handleAudioProcessing = async (audioFiles) => {
    const promises = audioFiles.map(processSingleAudioFile);
    const processedAudios = await Promise.all(promises);
    const successfulAudios = processedAudios.filter((audio) => audio !== null);
    setAudioFiles((prev) => {
      const newFiles = [...prev, ...successfulAudios];
      setFilteredAudioFiles(newFiles);
      return newFiles;
    });
  };

  const processSingleAudioFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = () => {
        const audioUrl = URL.createObjectURL(file);
        const audio = new Audio(audioUrl);

        audio.onloadedmetadata = () => handleLoadedMetadata(audio, file, audioUrl, resolve);
        audio.onerror = () => resolve(null);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const handleLoadedMetadata = async (audio, file, audioUrl, resolve) => {
    const secureId = generateSecureId();
    const uploadData = {
      roomID: roomID,
      audioContentType: file.type || "audio/mp3",
      fileName: file.name,
    };
    console.log('📤 Requesting S3 upload URL with data:', uploadData);
    let res;
    try {
      res = await getAudioUploadUrl(uploadData);
      console.log('📥 getAudioUploadUrl response:', res);
      let key = await uploadToS3(res, file);
        try {
          console.log('📤 Sending updateAudioUploadStatus payload:', { audioID: res.audioID, status: 'completed' });
          await updateAudioUploadStatus(res.audioID, 'completed');
          console.log('✅ Status updated to completed');
        } catch (statusError) {
          console.warn('⚠️ Could not update status, but file uploaded:', statusError);
      }
      resolve({
        id: secureId,
        name: file.name,
        duration: audio.duration,
        url: audioUrl,
        file: file,
        audioKey: key,
        isDefault: false,
      });
    } catch (error) {
      console.error("Audio upload failed:", error);
       if (res?.audioID) {
        try {
          console.log('📤 Sending updateAudioUploadStatus payload:', { audioID: res.audioID, status: 'failed' });
          await updateAudioUploadStatus(res.audioID, 'failed');
          console.log('✅ Marked as failed in database');
        } catch (failError) {
          console.warn('⚠️ Could not mark as failed:', failError);
        }
      }
      resolve(null);
    }
  };

  const generateSecureId = () => {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return `${Date.now()}-${array[0]}`;
  };

  const uploadToS3 = async (res, file) => {
    console.log('🔍 uploadToS3 received response:', res);
    if (res?.audioKey && res?.uploadUrl) {
      const { audioKey, uploadUrl } = res;
      console.log('✅ Valid response, uploading to S3 with audioKey:', audioKey);

      const uploadResult = await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type || "audio/mp3",
        },
      });

      if (!uploadResult.ok) {
        throw new Error("Upload to S3 failed");
      }

      console.log("Uploaded Successfully", uploadResult);
      return audioKey;
    }

    console.error('❌ Missing audioKey or uploadUrl in response:', res);
    throw new Error("Failed to get S3 upload URL");
  };

  const handleAudioFileChange = (e) => processAudioFiles(e.target.files);

  const handleSave = async () => {
    pausePlayback();
    if (startTime < 0) setStartTime(0);
    if (endTime > duration) setEndTime(duration);

    triggerLoader("Processing trimming...");
    try {
      const inputBody = {
        startTime: parseInt(startTime),
        endTime: parseInt(endTime),
        roomID,
        mp4file: mp4File,
        bucketName,
        duration,
        videoSegments: segments.map((segment) => ({
          id: segment.id,
          startTime: parseInt(segment.start),
          endTime: parseInt(segment.end),
          videoAudioVolume: segmentVolumes[segment.id] || segment.videoAudioVolume || videoAudioVolume,
        })),
      };
      
      if (selectedAudios.length > 0) {
        inputBody.audioTracks = selectedAudios.map((audio) => {
          const trimmedStart = parseInt(audio.audioStartTime);
          const trimmedEnd = parseInt(audio.audioEndTime);
          const startIn = parseInt(audio.audioStartInTimeINVideo || 0);
          const endIn = parseInt(audio.audioEndInTimeINVideo || startIn + Math.max(0, audio.audioEndTime - audio.audioStartTime));

          return {
            isDefault: audio.isDefault,
            audioKey: audio.audioKey,
            audioStartPoint: trimmedStart,
            audioEndPoint: trimmedEnd,
            audioStartTimeInVideo: startIn,
            audioEndTimeInVideo: endIn,
            overlayAudioVolume: audio.overlayAudioVolume || 1,
          };
        });
      }
      const response = await trimVideo(inputBody);
      hideLoader();
      const minutes = parseInt(totalTimelineDuration / 360) < 1 ? 1 : parseInt(totalTimelineDuration / 360);
      navigate(`/shows/details/${showId}`, {
        state: { 
          showProcessingMessage: true,
          processingDuration: minutes
        }
      });
    } catch (error) {
      console.error("Error during trim:", error);
      hideLoader();
    }
  };

  const handlePlayerPause = () => {
    setIsPlaying(false);
    setToggleButton(false);
    if (audioPlayerRef.current) {
      audioPlayerRef.current.pause();
      audioPlayerRef.current.currentTime = 0;
    }
  };

    const handleSplit = () => {
    console.log("Splitting at marker position:", markerPositionPx, "with duration:", duration);
    if (!markerPositionPx || !duration) return;
    const timeline = timelineTicksContentRef.current;
    const rect = timeline.getBoundingClientRect();
    const splitTime = (markerPositionPx / rect.width) * totalTimelineDuration;
    
    if (selectedAudioIndex !== null) {
      const audioToSplit = selectedAudios[selectedAudioIndex];
      const audioStart = audioToSplit.audioStartInTimeINVideo || 0;
      const audioEnd = audioToSplit.audioEndInTimeINVideo || 0;
      
      if (splitTime > audioStart && splitTime < audioEnd) {
        const firstClipDuration = splitTime - audioStart;
        const secondClipStart = splitTime;
        
        const firstClip = {
          ...audioToSplit,
          id: `${audioToSplit.id}-split-1`,
          audioEndInTimeINVideo: splitTime,
          audioEndTime: audioToSplit.audioStartTime + firstClipDuration,
        };
        
        const secondClip = {
          ...audioToSplit,
          id: `${audioToSplit.id}-split-2`,
          audioStartInTimeINVideo: secondClipStart,
          audioStartTime: audioToSplit.audioStartTime + firstClipDuration,
        };
        
        setSelectedAudios(prev => {
          const newAudios = [...prev];
          newAudios.splice(selectedAudioIndex, 1, firstClip, secondClip);
          return newAudios;
        });
        
        setSelectedAudioIndex(null);
        pushToHistory(captureState());
        return;
      }
    }
    
    if (sumOfVideoDuration <= splitTime) {
      showError("Split time exceeds total video duration");
      return;
    }

    setSegments((prevSegments) => {
      const newSegments = [];
      let remainingSplitTime = splitTime;
      let splitPerformed = false;
      let position = 0;
      prevSegments.forEach((segment) => {
        const segmentDuration = segment.end - segment.start;

        if (!splitPerformed) {
          if (remainingSplitTime > 0 && remainingSplitTime < segmentDuration) {
            let nextPosition = position + 1;
            const segmentVolume = segmentVolumes[segment.id] || segment.videoAudioVolume || videoAudioVolume;
            newSegments.push(
              { start: segment.start, end: segment.start + remainingSplitTime, id: position, videoAudioVolume: segmentVolume },
              { start: segment.start + remainingSplitTime, end: segment.end, id: nextPosition, videoAudioVolume: segmentVolume }
            );
            splitPerformed = true;
            position = nextPosition + 1;
          } else if (remainingSplitTime >= segmentDuration) {
            const segmentVolume = segmentVolumes[segment.id] || segment.videoAudioVolume || videoAudioVolume;
            newSegments.push({ start: segment.start, end: segment.end, id: position, videoAudioVolume: segmentVolume });
            remainingSplitTime -= segmentDuration;
            position++;
          }
        } else {
          newSegments.push({ start: segment.start, end: segment.end, id: position });
          position++;
        }
      });

      if (!splitPerformed) {
        return prevSegments;
      }

      return newSegments;
    });

    pushToHistory(captureState());
  };

  const handleSegmentSelect = (segment) => {
    setSelectedAudioIndex(null);
    let segmentId = segment?.id;
    let item = segment?.id === selectedSegment?.id ? null : segment;
    setIsVideoSelected(item ? true : false);
    setSelectedSegment(segmentId === selectedSegment?.id ? null : segment);
    
    if (item) {
      const segmentVolume = segmentVolumes[segment.id] !== undefined ? segmentVolumes[segment.id] : segment.videoAudioVolume;
      if (segmentVolume !== undefined) {
        setVideoAudioVolume(segmentVolume);
      }
    }
    
    pushToHistory(captureState());
  };

  const handleDeleteVideo = () => {
    pausePlayback();
    if (selectedSegment !== null) {
      setSegments((prevSegments) => prevSegments.filter((segment) => segment.id !== selectedSegment.id));
      setSelectedSegment(null);
      setIsVideoSelected(false);
      pushToHistory(captureState());
    }
  };

  const handleCopyVideo = () => {
    const segmentToCopy = segments.find((seg) => seg.id === selectedSegment?.id);
    if (!segmentToCopy) {
      console.log("No segment found to copy!");
      return;
    }

    setCopiedVideoSegment(segmentToCopy);
    setShowPasteIconForVideo(true);
    pushToHistory(captureState());
    console.log("Copied video segment:", {
      start: segmentToCopy.start,
      end: segmentToCopy.end,
    });
  };

  const handlePasteVideo = () => {
    if (!copiedVideoSegment) return;
    const newSegment = {
      ...copiedVideoSegment,
      start: copiedVideoSegment?.start,
      end: copiedVideoSegment?.end,
      id: segments.length > 0 ? segments[segments.length - 1].id + 1 : 0,
      isCopied: true,
      videoAudioVolume: copiedVideoSegment?.videoAudioVolume || videoAudioVolume,
    };

    const updated = [...segments, newSegment];
    setSegments(updated);

    pushToHistory(captureState());
    setShowPasteIconForVideo(false);
    setCopiedVideoSegment(null);
  };

  const handleFrameDragStart = (e, segmentId) => {
    setDraggedSegmentId(segmentId);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleFrameDragOver = (e, segmentId) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";

    if (draggedSegmentId === null || draggedSegmentId === segmentId) {
      return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const mouseX = e.clientX;
    const elementCenter = rect.left + rect.width / 2;

    const side = mouseX < elementCenter ? "left" : "right";
  };

  const handleFrameDragLeave = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
    }
  };

  const handleFrameDrop = (e, dropSegmentId) => {
    console.log("handledragand dropvideo");
    e.preventDefault();

    if (draggedSegmentId === null) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const mouseX = e.clientX;
    const elementCenter = rect.left + rect.width / 2;
    const isRightSide = mouseX >= elementCenter;

    const draggedIndex = segments.findIndex((seg) => seg.id === draggedSegmentId);
    const dropIndex = segments.findIndex((seg) => seg.id === dropSegmentId);

    if (draggedIndex === -1 || dropIndex === -1) return;

    let insertIndex = isRightSide ? dropIndex + 1 : dropIndex;
    if (draggedIndex < insertIndex) insertIndex--;

    if (draggedIndex === insertIndex) {
      setDraggedSegmentId(null);
      return;
    }

    const newSegments = [...segments];
    const [draggedSegment] = newSegments.splice(draggedIndex, 1);
    newSegments.splice(insertIndex, 0, draggedSegment);

    const updatedSegments = newSegments.map((seg, index) => ({
      ...seg,
      id: index,
      videoAudioVolume: segmentVolumes[seg.id] || seg.videoAudioVolume || videoAudioVolume,
    }));

    setSegments(updatedSegments);
    setDraggedSegmentId(null);
    
    // Reset playback to first segment after reordering
    setCurrentSegmentIndex(0);
    if (playerRef.current && updatedSegments.length > 0) {
      playerRef.current.seekTo(updatedSegments[0].start, "seconds");
      setPolygonStartTime(0);
      setCurrentPlayTime(0);
    }
  };

  const handleFrameDragEnd = () => {
    setDraggedSegmentId(null);
  };

  const updateAudioTimeInVideo = () => {
    if (selectedAudios.length === 0) return;

    setSelectedAudios((prev) => {
      const updated = prev.map((audio, index) => {
        if (Number.isFinite(audio?.audioStartInTimeINVideo)) {
          const trimmedLen = Math.max(0, audio.audioEndTime - audio.audioStartTime);
          const newEnd = (audio.audioStartInTimeINVideo || 0) + trimmedLen;
          return {
            ...audio,
            audioEndInTimeINVideo: parseInt(newEnd),
          };
        }
        const timelineWidth = audioTimelineRef.current?.getBoundingClientRect().width || 1;
        const segmentDuration = endTime - startTime;
        const panOffset = panOffsets[index] || 0;
        const audioStartPx = panOffset + (audio.audioStartTime / segmentDuration) * timelineWidth;
        const positionPercentage = audioStartPx / timelineWidth;
        const audioStartTimeInVideo = startTime + positionPercentage * segmentDuration;
        const audioDuration = audio.audioEndTime - audio.audioStartTime;
        const audioEndTimeInVideo = audioStartTimeInVideo + audioDuration;

        return {
          ...audio,
          audioStartInTimeINVideo: parseInt(audioStartTimeInVideo),
          audioEndInTimeINVideo: parseInt(audioEndTimeInVideo),
        };
      });

      return updated;
    });
  };

  const parseTimeToSeconds = (str) => {
    if (!str) return 0;
    const parts = str.split(":").map((p) => p.trim());
    if (parts.some((p) => p === "" || isNaN(Number(p)))) return NaN;
    let seconds = 0;
    if (parts.length === 3) {
      const [hh, mm, ss] = parts.map(Number);
      seconds = hh * 3600 + mm * 60 + ss;
    } else if (parts.length === 2) {
      const [mm, ss] = parts.map(Number);
      seconds = mm * 60 + ss;
    } else if (parts.length === 1) {
      seconds = Number(parts[0]);
    } else {
      return NaN;
    }
    return Math.max(0, Math.floor(seconds));
  };

  const applyWindowToSegments = (virtualStart, virtualEnd) => {
    // Trim the concatenated segments to [virtualStart, virtualEnd) in virtual time
    const clampedStart = Math.max(0, virtualStart);
    const clampedEnd = Math.max(clampedStart, Math.min(virtualEnd, totalTimelineDuration));
    if (clampedEnd <= clampedStart) return;

    let cumulative = 0;
    const newSegments = [];
    segments.forEach((seg) => {
      const segLen = Math.max(0, seg.end - seg.start);
      const segVirtualStart = cumulative;
      const segVirtualEnd = cumulative + segLen;
      const overlapStart = Math.max(segVirtualStart, clampedStart);
      const overlapEnd = Math.min(segVirtualEnd, clampedEnd);
      if (overlapEnd > overlapStart) {
        const offsetStartInSeg = overlapStart - segVirtualStart;
        const offsetEndInSeg = overlapEnd - segVirtualStart;
        const segmentVolume = segmentVolumes[seg.id] || seg.videoAudioVolume || videoAudioVolume;
        newSegments.push({ 
          start: seg.start + offsetStartInSeg, 
          end: seg.start + offsetEndInSeg,
          videoAudioVolume: segmentVolume
        });
      }
      cumulative += segLen;
    });

    const normalized = newSegments
      .filter((s) => s.end > s.start)
      .map((s, i) => ({ ...s, id: i }));

    if (normalized.length > 0) {
      setSegments(normalized);
      // Reset playback to new first segment
      if (playerRef.current) {
        setCurrentSegmentIndex(0);
        playerRef.current.seekTo(normalized[0].start, "seconds");
        setPolygonStartTime(0);
        setCurrentPlayTime(0);
      }
    }
  };

  const beginEditRange = () => {
    // initialize with full range by default
    setEditStartInput(formatTime(0));
    setEditEndInput(formatTime(totalTimelineDuration));
    setIsEditingRange(true);
  };

  const applyEditedRange = () => {
    const startSec = parseTimeToSeconds(editStartInput);// Converts text input to seconds
    const endSec = parseTimeToSeconds(editEndInput);// Converts text input to seconds

    if (!Number.isFinite(startSec) || !Number.isFinite(endSec)) {
      showError("Invalid time format. Use HH:MM:SS or MM:SS.");
      return;
    }
    if (startSec < 0 || endSec < 0 || startSec >= endSec) {
      showError("Start must be before End, and both non-negative.");
      return;
    }
    if (startSec >= totalTimelineDuration) {
      showError("Start time exceeds total timeline duration.");
      return;
    }
    
    // Save state before applying changes for undo/redo
    pushToHistory(captureState());
    applyWindowToSegments(startSec, endSec);// Applies the new time range
    // Push the new state after changes
    pushToHistory(captureState());
    setIsEditingRange(false);
  };

  const handleRangeKeyDown = (e) => {
    if (e.key === "Enter") {
      applyEditedRange();
    } else if (e.key === "Escape") {
      setIsEditingRange(false);
    }
  };

  const getTrimBounds = useCallback(() => { //Gets current time boundaries for validation
    if (!segments || segments.length === 0) {
      return { start: 0, end: duration || 0 };
    }
    // Find the actual min and max bounds from all segments
    const allStarts = segments.map(seg => seg.start);
    const allEnds = segments.map(seg => seg.end);
    const start = Math.max(0, Math.min(...allStarts));
    const end = Math.max(start, Math.max(...allEnds));
    return { start, end };
  }, [segments, duration]);

  const toggleVideoMute = () => {
    setIsVideoMuted(prev => !prev);
  };

  const toggleAudioMute = (audioKey) => {
    setMutedAudioKeys(prev => {
      const newSet = new Set(prev);
      if (newSet.has(audioKey)) {
        newSet.delete(audioKey);
      } else {
        newSet.add(audioKey);
      }
      
      if (audioPlayerRef.current && playingAudioIndex !== null) {
        const playingAudio = selectedAudios[playingAudioIndex];
        const playingAudioKey = playingAudio?.audioKey || playingAudio?.id;
        if (playingAudioKey === audioKey) {
          const currentAudioVolume = selectedAudioIndex === playingAudioIndex ? audioVolume : (playingAudio.overlayAudioVolume || 1);
          audioPlayerRef.current.volume = newSet.has(audioKey) ? 0 : currentAudioVolume;
        }
      }
      
      return newSet;
    });
  };

  const deleteAudioTimeline = (audioKey) => {
    pausePlayback();
    setSelectedAudios(prev => prev.filter(audio => {
      const aKey = audio.audioKey || audio.id;
      return aKey !== audioKey;
    }));
    pushToHistory(captureState());
  };

  const calculateLaneDuration = (audioKey) => {
    const clipsForThisAudio = selectedAudios
      .map((audio, index) => ({ audio, index }))
      .filter(({ audio }) => {
        const aKey = audio.audioKey || audio.id;
        return aKey === audioKey;
      });

    const totalDuration = clipsForThisAudio.reduce((sum, { audio }) => {
      const effectiveDuration = Math.max(0, audio.audioEndTime - audio.audioStartTime);
      return sum + effectiveDuration;
    }, 0);

    return totalDuration;
  };

  useEffect(() => {
    const videoAudioBarWrapper = document.querySelector('.video-audio-bar-wrapper');
    const topContainer = topContainerRef.current;
    
    if (!videoAudioBarWrapper || !topContainer) return;

    const handleScroll = () => {
      const scrollableContainer = videoAudioBarWrapper;
      
      if (!scrollableContainer) {
        topContainer.style.maxHeight = '';
        topContainer.style.transition = 'max-height 0.3s ease-out';
        setIsTimelineScrolling(false);
        return;
      }
      
      const scrollTop = scrollableContainer.scrollTop;
      const scrollHeight = scrollableContainer.scrollHeight;
      const clientHeight = scrollableContainer.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      
      const scrollPercent = maxScroll > 0 ? Math.min(scrollTop / maxScroll, 1) : 0;
      
      const mediaContainer = topContainer.closest('.media-container');
      if (mediaContainer) {
        const containerHeight = mediaContainer.clientHeight;
        const maxShrink = containerHeight * 0.25;
        const heightAdjustment = scrollPercent * maxShrink;
        const heightAdjustmentVh = (heightAdjustment / window.innerHeight) * 100;
        const newMaxHeight = `calc(100% - ${heightAdjustmentVh}vh)`;
        topContainer.style.transition = 'max-height 0.2s ease-out';
        topContainer.style.maxHeight = newMaxHeight;
        
        setIsTimelineScrolling(scrollPercent > 0.05);
      }
    };

    videoAudioBarWrapper.addEventListener('scroll', handleScroll, { passive: true });
    
    const resizeObserver = new ResizeObserver(() => {
      setTimeout(handleScroll, 10);
    });
    
    resizeObserver.observe(videoAudioBarWrapper);
    
    setTimeout(handleScroll, 100);

    return () => {
      videoAudioBarWrapper.removeEventListener('scroll', handleScroll);
      resizeObserver.disconnect();
    };
  }, [selectedAudios.length]);

  useEffect(() => {
    if (!isResizingTimeline || !resizeStartRef.current) return;

    const handleMouseMove = (e) => {
      if (!resizeStartRef.current || !bottomContainerRef.current) return;
      
      const deltaY = resizeStartRef.current.startY - e.clientY;
      // Convert px to vh: 200px = 20vh, 420px = 42vh
      const newHeightVh = Math.max(20, Math.min(42, resizeStartRef.current.startHeight + (deltaY / window.innerHeight) * 100));
      
      bottomContainerRef.current.style.maxHeight = `${newHeightVh}vh`;
      setTimelineHeight(newHeightVh);
    };

    const handleMouseUp = () => {
      setIsResizingTimeline(false);
      resizeStartRef.current = null;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.body.style.cursor = 'ns-resize';
    document.body.style.userSelect = 'none';

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isResizingTimeline]);

  const handleTimelineResizeStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!bottomContainerRef.current) return;
    
    const rect = bottomContainerRef.current.getBoundingClientRect();
    setIsResizingTimeline(true);
    // Convert height from pixels to vh (1vh = window.innerHeight / 100)
    const heightInVh = (rect.height / window.innerHeight) * 100 || timelineHeight || 40;
    resizeStartRef.current = {
      startY: e.clientY,
      startHeight: heightInVh
    };
  };

  const ensurePlayerInBounds = (internal, currentSegment) => {
    const current = internal && typeof internal.currentTime === "number" ? internal.currentTime : null;
    if (!currentSegment || current === null) return;
    
    const { start: trimStart, end: trimEnd } = getTrimBounds();
    const segmentStart = Math.max(currentSegment.start, trimStart);
    const segmentEnd = Math.min(currentSegment.end, trimEnd);
    
    if (current < segmentStart || current > segmentEnd) {
      playerRef.current.seekTo(segmentStart, "seconds");
    }
  };

  const updatePlayerVolume = (internal) => {
    if (internal?.volume === undefined) return;
    
    const targetVolume = segmentVolumes[selectedSegment?.id] ?? videoAudioVolume;
    internal.volume = isVideoMuted ? 0 : targetVolume;
  };

  const handlePlayerPlay = () => {
    if (!playerRef.current) return;
    
    const internal = playerRef.current.getInternalPlayer?.();
    const currentSegment = segments[currentSegmentIndex];
    
    ensurePlayerInBounds(internal, currentSegment);
    updatePlayerVolume(internal);
  };

  const value = useSelector((state) => state?.value);

  return (
    <>
      <div className={`theme-bg clr-white height-100 ${info?.show ? "blur-background" : ""}`} style={{ display: "flex" }}>
        <SideBar />
        <div className="container-fluid overflow-x-none ml-80p height-100" style={{ overflowY: "auto" }}>
          <div className="row">
            <div className="container" style={{ color: "#fff" }}>
              <div className="no-padding-page">
                <Pageheader pageTitle={`Shows > ${showDetails?.ShowName || "Video File"}`} handlePageClick={handleCancel} />
              </div>
            <div className="profilepage_container_edit" style={{ marginBottom: "0.8vh", paddingLeft: "3.2vh", paddingRight: "3.2vh" }}>
              <div className="profilepage_container_editTitle">
                <button onClick={handleCancel} aria-label="Back" className="back-button">
                  <img src={LeftArrow} alt="" aria-hidden="true" />
                </button>
                <span>Editing</span>
              </div>
              <div className="profilepage_container_editButton">
                <button className="profilepage_container_cancelButton" onClick={handleCancel}>
                  <span>Cancel</span>
                  <img src={xIcon} alt="Cancel" />
                </button>
                <button className="profilepage_container_saveButton" onClick={handleSave}>
                  <span>Save</span>
                  <img src={Tick} alt="Save" />
                </button>
              </div>
            </div>
            <div className="media-container">
              <div className="top-container" ref={topContainerRef}>

                <div className="your-audio-wrapper" style={{ position: 'relative' }}>
                  {isHovered && <img src={Notify} className="notify" alt="Notification" />}
                  <div className="editing-left-wrapper">
                    <div className="editing-left-panel">
                      <div className="album-name">
                        <img src={Music} alt="Album" />
                        <span className="panel-title">Your Audio</span>
                      </div>
                      <div className="import-audio-button-container">
                        <button className="import-audio-button" onClick={handleImportAudioClick}>
                          Import Audio
                        </button>
                        <input type="file" ref={fileInputRef} onChange={handleAudioFileChange} accept="audio/*" multiple style={{ display: "none" }} />
                      </div>
                    </div>
                  </div>
                  <div className="tab-container">
                    <ToggleTypeSelector
                      TYPE_Items={TYPE_Items}
                      handleSearchTypeChange={handleTabChange}
                      toggleType={activeTab === 'samples' ? 'Samples' : 'My Files'}
                    />
                  </div>
                  {activeTab === "samples" && <AudioSearch onSearch={handleSamplesSearch} searchTerm={samplesSearchTerm} onSearchTermChange={setSamplesSearchTerm} />}
                  {activeTab === "myfiles" && <AudioSearch onSearch={handleMyFilesSearch} searchTerm={myFilesSearchTerm} onSearchTermChange={setMyFilesSearchTerm} />}
                  <div className="audio-list">
                    {activeTab === "samples" ? (
                      filteredDefaultAudios.map((audio, index) => {
                        const isSelected = selectedAudios.some((a) => a.audioKey === audio.audioKey || a.id.startsWith(audio.id));
                        const isPlaying = currentlyPlayingAudio?.id === audio.id && playState;
                        return (
                          <div key={audio.id}>
                            <div className="audio-item">
                              <Tooltip title={isWaveformLoading ? "Waveform loading, please wait" : ""} placement="right-end">
                                <div
                                  className="audio-icon"
                                  onClick={() => !isWaveformLoading && handleToggle(audio)}
                                  onKeyDown={(e) => {
                                    if (!isWaveformLoading && (e.key === "Enter" || e.key === " ")) {
                                      e.preventDefault();
                                      handleToggle(audio);
                                    }
                                  }}
                                  role="button"
                                  tabIndex={0}
                                  aria-disabled={isWaveformLoading}
                                  aria-label={isPlaying ? "Pause audio" : "Play audio"}
                                  style={{
                                    cursor: isWaveformLoading ? "not-allowed" : "pointer",
                                    opacity: isWaveformLoading ? 0.5 : 1,
                                  }}
                                >
                                  <img src={samplebg} alt="" className="background-icon" aria-hidden="true" />
                                  <img src={isPlaying ? Pause : play_button} className="play-button" alt={isPlaying ? "Pause" : "Play"} aria-hidden="true" />
                                </div>
                              </Tooltip>
                              <div className="audio-info">
                                <div className="audio-wrap">
                                  <span className="audio-title">{audio.name}</span>
                                  <span className="audio-duration">{formatTime(audio.duration, true)}</span>
                                </div>
                                <div className="waveform-add-wrapper">
                                  <Tooltip title={isWaveformLoading ? "Waveform loading please wait" : ""} placement="right-end">
                                    <div
                                      className="Vector-button"
                                      style={{
                                        cursor: isWaveformLoading ? "not-allowed" : "pointer",
                                      }}
                                    >
                                    <Tooltip title={isSelected ? "Remove from timeline" : "Add to timeline"} placement="top">
                                      <button
                                        onClick={() => handleSelectDefaultAudio(audio)}
                                        aria-label={isSelected ? "selected" : "add"}
                                        className="icon-button"
                                        disabled={isWaveformLoading}
                                      >
                                          <img src={isSelected ? Tick : Vector} alt={isSelected ? "Selected" : "Add"} aria-hidden="true" style={isSelected ? { width: "2.4vh", height: "2.4vh" } : {}} />
                                        </button>
                                    </Tooltip>
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="uploaded-wrapper">
                        <section
                          className={`uploaded-audio-container ${audioFiles.length === 0 ? 'no-audio' : ''}`}
                          aria-label="Audio file drop zone"
                          onDragOver={(e) => {
                            e.preventDefault();
                          }}
                          onDragLeave={(e) => {
                            e.preventDefault();
                          }}
                          onDrop={async (e) => {
                            e.preventDefault();
                            processAudioFiles(e.dataTransfer.files);
                          }}
                        >
                          {audioFiles.length === 0 ? (
                            <div className="no-audio-uploaded">
                              <img src={album} alt="Album" className="album-image"/>
                              <span className="no-audio-text1">No files uploaded</span>
                              <span className="no-audio-text2">Click Import Audio to add files</span>
                            </div>
                            
                          ) : (
                            filteredAudioFiles.map((audio, index) => {
                              const isSelected = selectedAudios.some((a) => a.audioKey === audio.audioKey || a.id.startsWith(audio.id));
                              const isPlaying = currentlyPlayingAudio?.id === audio.id && playState;
                              const bgImage = getBackgroundImage(index);
                              return (
                                <div key={audio.id}>
                                  <div className="audio-item">
                                    <AudioIcon audio={audio} isPlaying={isPlaying} isWaveformLoading={isWaveformLoading} bgImage={bgImage} onToggle={handleToggle} />
                                    <div className="audio-info">
                                      <AudioInfo audio={audio} isSelected={isSelected} isWaveformLoading={isWaveformLoading} onSelect={handleSelectAudio} onDelete={handleDeleteMyAudio} showDelete={true} />
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </section>
                        <div className="import-audio-section">
                          <div className="info" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} aria-label="More information">
                            <img src={isHovered ? Question2 : Question1} alt="Info" className="info-size" />
                          </div>
                          <button className="drag-drop-box" onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} aria-label="Drag and drop audio files here">
                            <span className="drag-drop-title">Drag and Drop Audio</span>
                            <img className="drag-drop-icon" src={drag} alt="Drag and drop icon" />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`video-container-editing ${isHovered ? "blur-on-hover" : ""}`}
                  ref={containerRef}
                  onMouseMove={(e) => {
                    if (dragging) {
                      handleTimelineDrag(e);
                    }
                  }}
                  onMouseUp={() => {
                    setDragging(null);
                    handleDragEnd();
                  }}
                  onMouseLeave={() => {
                    setDragging(null);
                    handleDragEnd();
                  }}
                  role="presentation"
                  aria-label="Video player container"
                >
                  <div className="whiteboard-container">
                    <div className="video-wrapper">
                      <EditingVideoPlayer
                        playerRef={playerRef}
                        url={showDetails?.ShowURL}
                        playing={isPlaying}
                        volume={(() => {
                          if (isVideoMuted) return 0;
                          return segmentVolumes[selectedSegment?.id] ?? videoAudioVolume;
                        })()}
                        onDuration={onDuration}
                        onProgress={onProgress}
                        onSeek={onSeek}
                        onPlay={handlePlayerPlay}
                        onPause={handlePlayerPause}
                        onError={handlePlayerPause}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom-container" ref={bottomContainerRef} style={{ maxHeight: timelineHeight ? `${Math.min(timelineHeight, 42)}vh` : '42vh' }}>
                <button 
                  className="timeline-resize-handle" 
                  style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', zIndex: 50, padding: '0.8vh 0vh', cursor: 'ns-resize', background: 'none', border: 'none' }}
                  onMouseDown={handleTimelineResizeStart}
                  aria-label="Resize timeline"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleTimelineResizeStart(e);
                    }
                  }}
                >
                  <div 
                    style={{ width: '4.8vh', height: '0.4vh', backgroundColor: 'rgba(255, 255, 255, 0.3)', borderRadius: '999vh', transition: 'all 0.2s', boxShadow: '0 0.1vh 0.2vh rgba(0, 0, 0, 0.1)' }} 
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'} 
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'} 
                    aria-hidden="true"
                  />
                  <div style={{ position: 'absolute', top: '-0.4vh', bottom: '-0.4vh', left: '-1.6vh', right: '-1.6vh', cursor: 'ns-resize' }} aria-hidden="true" />
                </button>
                <div
                  className="editing-box"
                  ref={timelineRef}
                  onMouseMove={(e) => {
                    if (dragging) {
                      handleTimelineDrag(e);
                    }
                  }}
                  onMouseUp={() => {
                    setDragging(null);
                    handleDragEnd();
                  }}
                  onMouseLeave={() => {
                    setDragging(null);
                    handleDragEnd();
                  }}
                  role="application"
                  tabIndex="0"
                  aria-label="Timeline video container"
                >
                  <div className="editing-settings">
                    <div className="edit-settings-left">
                      <Tooltip title="Undo" placement="top">
                        <button
                          onClick={undo}
                          disabled={historyIndex <= 0}
                          aria-label="Undo"
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: historyIndex > 0 ? "pointer" : "not-allowed",
                            opacity: historyIndex > 0 ? 1 : 0.5,
                          }}
                        >
                          <img src={Undo} alt="" aria-hidden="true" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
                        </button>
                      </Tooltip>
                      <Tooltip title="Redo" placement="top">
                        <button
                          onClick={redo}
                          disabled={future.length === 0}
                          aria-label="Redo"
                          style={{
                            cursor: future.length > 0 ? "pointer" : "not-allowed",
                            opacity: future.length > 0 ? 1 : 0.5,
                            background: "none",
                            border: "none",
                          }}
                        >
                          <img src={Redo} alt="" aria-hidden="true" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
                        </button>
                      </Tooltip>
                      <Tooltip title="Trim" placement="top">
                        <button
                          onClick={handleSplit}
                          aria-label="Trim audio"
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                          }}
                        >
                          <img src={trim} alt="Trim" aria-hidden="true" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
                        </button>
                      </Tooltip>
                      {selectedAudioIndex !== null ? (
                        <AudioCopyPasteButton 
                          showPasteIcon={showPasteIcon}
                          onCopy={handleCopyAudio}
                          onPaste={handlePasteAudio}
                        />
                      ) : isVideoSelected ? (
                        <VideoCopyPasteButton 
                          showPasteIcon={showPasteIconForVideo}
                          onCopy={handleCopyVideo}
                          onPaste={handlePasteVideo}
                        />
                      ) : (
                        <DisabledCopyButton />
                      )}
                      <Tooltip title="Delete" placement="top">
                        <button
                          onClick={() => {
                            if (selectedAudioIndex !== null) {
                              handleDeleteAudio();
                            } else if (selectedSegment !== null) {
                              handleDeleteVideo();
                            }
                          }}
                          disabled={selectedAudioIndex === null && selectedSegment === null}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: selectedAudioIndex !== null || selectedSegment !== null ? "pointer" : "not-allowed",
                            opacity: selectedAudioIndex !== null || selectedSegment !== null ? 1 : 0.5,
                          }}
                          aria-label="Delete"
                        >
                          <img src={deleteIcon} alt="Delete" className="edit-settings-left-icon" style={{ width: "3.2vh", height: "3.2vh" }}/>
                        </button>
                      </Tooltip>
                      <VolumeSlider
                        title="Video Audio Volume"
                        icon={Vector}
                        alt="Volume"
                        showSlider={showVolumeSlider}
                        setShowSlider={setShowVolumeSlider}
                        setOtherSlider={setShowAudioVolumeSlider}
                        volume={videoAudioVolume}
                        setVolume={setVideoAudioVolume}
                        iconSize="1.8vh"
                        onVolumeChange={(newVolume) => {
                          if (selectedSegment) {
                            setSegmentVolumes(prev => ({
                              ...prev,
                              [selectedSegment.id]: newVolume
                            }));
                          } else {
                            setVideoAudioVolume(newVolume);
                          }
                          if (playerRef.current && !isVideoMuted) {
                            const internal = playerRef.current.getInternalPlayer();
                            if (internal) {
                              internal.volume = newVolume;
                            }
                          }
                        }}
                        ariaLabel="Volume control"
                      />
                      <VolumeSlider
                        title="Audio Volume"
                        icon={Music}
                        alt="Audio Volume"
                        showSlider={showAudioVolumeSlider}
                        setShowSlider={setShowAudioVolumeSlider}
                        setOtherSlider={setShowVolumeSlider}
                        volume={audioVolume}
                        setVolume={setAudioVolume}
                        iconSize="2.8vh"
                        disabled={selectedAudioIndex === null}
                        onVolumeChange={(newVolume) => {
                          if (selectedAudioIndex !== null) {
                            setSelectedAudios(prev => prev.map((audio, idx) => 
                              idx === selectedAudioIndex ? { ...audio, overlayAudioVolume: newVolume } : audio
                            ));
                            const selectedAudio = selectedAudios[selectedAudioIndex];
                            const audioKey = selectedAudio?.audioKey || selectedAudio?.id;
                            if (audioPlayerRef.current && !mutedAudioKeys.has(audioKey)) {
                              audioPlayerRef.current.volume = newVolume;
                            }
                          }
                        }}
                        ariaLabel="Audio volume control"
                      />
                      
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "1.6vh" }}>
                      <Tooltip title="Keyboard Shortcuts" placement="top">
                        <button onClick={() => setShowShortcuts(true)} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" ,outline: "none"}} aria-label="Keyboard shortcuts">
                          <svg style={{ width: "2.4vh", height: "2.4vh" }} fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="1.5">
                            <circle cx="12" cy="12" r="10" />
                            <path strokeLinecap="round" d="M12 16v-4M12 8h.01" />
                          </svg>
                        </button>
                      </Tooltip>
                    </div>
                    <div className="play-timer">
                      <button className="play-pause" onClick={toggleAudioPlay} style={{ width: "3.2vh", height: "3.2vh", background: "none", border: "none", padding: 0, cursor: "pointer" }}>
                        <img src={toggleButton ? Pause : playButton} alt={toggleButton ? "Pause" : "Play"} style={{ width: "100%", height: "100%" }} />
                      </button>
                      {!isEditingRange ? (
                        <Tooltip title="Double-click to edit range" placement="right">
                          <span
                            className="start-end-time"
                            onDoubleClick={beginEditRange}
                            style={{ cursor: "text" }}
                          >
                            {isDraggingHandle ? formatTime(tempTimeUpdate) : formatTime(polygonStartTime)} / {formatTime(totalTimelineDuration)}
                          </span>
                        </Tooltip>
                      ) : (
                        <span className="start-end-time" style={{ display: "inline-flex", gap: "0.8vh", alignItems: "center" }}>
                          <input
                            aria-label="Start time"
                            value={editStartInput}
                            onChange={(e) => setEditStartInput(e.target.value)}
                            onKeyDown={handleRangeKeyDown}
                            style={{ width: "9vh" }}
                            placeholder="HH:MM:SS"
                            autoFocus
                            className="edit-range-input"
                          />
                          <span>/</span>
                          <input
                            aria-label="End time"
                            value={editEndInput}
                            onChange={(e) => setEditEndInput(e.target.value)}
                            onKeyDown={handleRangeKeyDown}
                            style={{ width: "9vh" }}
                            placeholder="HH:MM:SS"
                            className="edit-range-input"
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="timelineticks" ref={timelineRef}>
                    <div style={{width:"11vh", height:"100%"}}></div>
                    <div ref={timelineTicksContentRef} style={{flex: 1, marginRight: "0.8vh"}}>
                      <TimelineTicks totalTimelineDuration={totalTimelineDuration} onDisplayDurationChange={setDisplayDuration} />
                    </div>
                  </div>
                  <PlayheadMarker
                    markerPositionPx={markerPositionPx}
                    formatTime={formatTime}
                    currentTime={isDraggingHandle ? tempTimeUpdate : polygonStartTime}
                    onMouseDown={(e) => {
                      const timeline = timelineTicksContentRef.current;
                      if (!timeline) return;
                      const rect = timeline.getBoundingClientRect();
                      const x = e.clientX - rect.left;
                      setIsDraggingMarker(true);
                      setMarkerPositionPx(x);
                      setIsMarkerFollowingPlayback(false);
                    }}
                  />
                  <div className="video-audio-bar-wrapper custom-scrollbar">
                    <div className="video-audio-bar" ref={videoAudioBarRef}>
                    <div
                      className="frame-slider-wrapper"
                      ref={videoTimelineRef}
                      style={{
                        position: "relative",
                        height: "8vh",
                        borderRadius: "0.4vh",
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                      }}
                    >
                    <div className="video-label-container">
                      <p className="video-label">Video</p>
                      <svg className="video-icon" viewBox="0 0 24 24" strokeWidth="2" onClick={toggleVideoMute} style={{cursor: 'pointer'}}>
                        {isVideoMuted ? (
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15zM17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                        )}
                      </svg>
                    </div>
                      <div
                        className="frames-loading-wrapper"
                        style={{
                          position: "relative",
                          display: "flex",
                          height: "100%",
                          width: "100%",
                          overflow: "hidden",
                        }}
                      >
                        {framesLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <CircularProgress size="3vh" style={{ color: "#fff" }} />
                          </Box>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              height: "100%",
                              width: `${(sumOfVideoDuration / totalTimelineDuration) * 100}%`,
                            }}
                          >
                            {segments.map((segment) => (
                              <div
                                key={segment?.id}
                                className={`segment-container ${selectedSegment?.id === segment?.id ? "selected-segment" : ""}
             ${draggedSegmentId === segment?.id ? "segment-dragging" : ""}`}
                                onClick={() => handleSegmentSelect(segment)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleSegmentSelect(segment);
                                  }
                                }}
                                role="button"
                                tabIndex={0}
                                aria-label={`Segment from ${segment.start} to ${segment.end}`}
                                aria-pressed={selectedSegment?.id === segment?.id}
                                draggable
                                onDragStart={(e) => handleFrameDragStart(e, segment?.id)}
                                onDragOver={handleFrameDragOver}
                                onDragLeave={handleFrameDragLeave}
                                onDrop={(e) => handleFrameDrop(e, segment?.id)}
                                onDragEnd={handleFrameDragEnd}
                                style={{
                                  width: `${((segment.end - segment.start) / sumOfVideoDuration) * 100}%`,
                                }}
                              >
                                <div
                                  className="frames-display-container"
                                  style={{
                                    clipPath: `inset(0% 0% 0% 0%)`,
                                    transform: videoPanOffset !== 0 ? `translateX(${videoPanOffset}px)` : undefined,
                                    height: "100%",
                                    borderRadius: "1.2vh",
                                    overflow: "hidden",
                                  }}
                                >
                                  {frames
                                    .filter((_, index) => (index * duration) / frames.length >= segment.start && (index * duration) / frames.length <= segment.end)
                                    .map((frame, index) => (
                                      <div
                                        key={frame}
                                        className="frames"
                                        style={{
                                          backgroundImage: `url(${frame})`,
                                          backgroundSize: "cover",
                                          flex: 1,
                                        }}
                                      ></div>
                                    ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="audio-track-container">
                      {selectedAudios.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "0.8vh" }}>
                          {(() => {
                            const audioGroups = {};
                            selectedAudios.forEach((audio, index) => {
                              const audioKey = audio.audioKey || audio.id;
                              if (!audioGroups[audioKey]) {
                                audioGroups[audioKey] = [];
                              }
                              audioGroups[audioKey].push({ audio, index });
                            });

                            const uniqueAudioKeys = [];
                            const seenKeys = new Set();
                            selectedAudios.forEach((audio) => {
                              const audioKey = audio.audioKey || audio.id;
                              if (!seenKeys.has(audioKey)) {
                                seenKeys.add(audioKey);
                                uniqueAudioKeys.push(audioKey);
                              }
                            });

                            return uniqueAudioKeys.map((audioKey, timelineIndex) => {
                              const clipsForThisAudio = audioGroups[audioKey];
                              const timelineRef = timelineIndex === 0 ? audioTimelineRef : null;
                              
                              return (
                                <div
                                  key={audioKey}
                                  className="audio-timeline-wrapper"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    height: "7vh",
                                    marginTop: "1vh",
                                    borderRadius: "0.4vh",
                                    overflow: "hidden",
                                    boxShadow: "0 0.4vh 1.2vh rgba(0, 0, 0, 0.5), 0 0.2vh 0.4vh rgba(0, 0, 0, 0.3)",
                                  }}
                                >
                                  <div className="audio-labels-container">
                                    <p className="audio-labels">{clipsForThisAudio[0]?.audio?.name?.replace(/\.[^/.]+$/, "").replace(/ \(copy\)$/, "") || "Audio"}</p>
                                    <div style={{display:"flex" , gap:"0.8vh"}}>
                                      <svg className="audio-icons" viewBox="0 0 24 24" strokeWidth="2" onClick={() => toggleAudioMute(audioKey)} style={{cursor: 'pointer'}}>
                                        {mutedAudioKeys.has(audioKey) ? (
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15zM17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
                                        ) : (
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
                                        )}
                                      </svg>
                                      <svg className="audio-delete-icon" viewBox="0 0 24 24" strokeWidth="2" fill="none" onClick={() => deleteAudioTimeline(audioKey)} style={{cursor: 'pointer'}}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                      </svg>
                                      <span className="audio-lane-duration">
                                        {formatTime(calculateLaneDuration(audioKey), true)}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="audio-timeline-container"
                                    ref={timelineRef}
                                    role="application"
                                    aria-label="Audio timeline"
                                    style={{
                                      position: "relative",
                                      height: "100%",
                                      flex: 1,
                                      overflow: "hidden",
                                      backgroundColor: "#0003",
                                      border: "none",
                                      padding: 0
                                    }}
                                    onMouseMove={handleTimelineDrag}
                                    onMouseUp={() => {
                                      setDragging(null);
                                    }}
                                    onMouseLeave={() => {
                                      setDragging(null);
                                    }}
                                  >
                                  {clipsForThisAudio.map(({ audio, index }) => {
                                    const trimmedDuration = Math.max(0, audio.audioEndTime - audio.audioStartTime);
                                    const timelineWidth = timelineReady ? (timelineRef?.current?.getBoundingClientRect().width || audioTimelineRef.current?.getBoundingClientRect().width || 0) : 0;
                                    const visibleWidth = (trimmedDuration / displayDuration) * timelineWidth;
                                    const panOffset = panOffsets[index] || 0;
                                    const globalStartPx = ((audio.audioStartInTimeINVideo || 0) / displayDuration) * timelineWidth;
                                    
                                    const leftPx = globalStartPx + panOffset;

                                    const isSelected = selectedAudioIndex === index;
                                    return (
                                      <button
                                        key={audio.id}
                                        className={`audio-clip ${isSelected ? "selected" : ""}`}
                                        style={{
                                          position: "absolute",
                                          width: `${visibleWidth}px`,
                                          left: `${leftPx}px`,
                                          height: "100%",
                                          backgroundColor: isSelected ? "rgba(41, 104, 254, 0.6)" : "transparent",
                                          borderRadius: "0.4vh",
                                          cursor: "grab",
                                          overflow: "hidden",
                                          userSelect: "none",
                                          touchAction: "none",
                                          border: "none",
                                          padding: 0
                                        }}
                                        onClick={(e) => onClickAudio(index)}
                                        onMouseDown={(e) => {
                                          if (!e.target.classList.contains("drag")) {
                                            e.stopPropagation();
                                            handleDragStart(`audio-pan-${index}`);
                                            setPanStartX(e.clientX);
                                          }
                                        }}
                                        onMouseUp={handleDragEnd}
                                      >
                                        <button
                                          className="drag drag-start"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            cursor: "ew-resize",
                                            height: "100%",
                                            backgroundColor: "#00f",
                                            zIndex: 10,
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                            handleDragStart(`audio-start-${index}`);
                                          }}
                                          onMouseUp={handleDragEnd}
                                        ></button>
                                        <div
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            overflow: "hidden",
                                            position: "relative",
                                          }}
                                        >
                                          <div
                                            style={{
                                              width:
                                                audio.originalStartTime !== undefined
                                                  ? `${100 / ((audio.originalEndTime - audio.originalStartTime) / audio.duration)}%`
                                                  : `${100 / ((audio.audioEndTime - audio.audioStartTime) / audio.duration)}%`,
                                              transform:
                                                audio.originalStartTime !== undefined
                                                  ? `translateX(-${(audio.originalStartTime / audio.duration) * 100}%)`
                                                  : `translateX(-${(audio.audioStartTime / audio.duration) * 100}%)`,
                                              height: "100%",
                                            }}
                                          >
                                            <AudioWaveform
                                              audioUrl={audio.url}
                                              height={waveformHeight}
                                              onWaveformReady={() => handleWaveformReady(audio.id)}
                                              isWaveformLoading={waveformLoadingStates[audio.id] || false}
                                            />
                                          </div>
                                          <AudioClipLabel audioName={audio.name.replace(/\.[^/.]+$/, "")} />
                                        </div>
                                        <button
                                          className="drag drag-end"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            cursor: "ew-resize",
                                            height: "100%",
                                            backgroundColor: "#00f",
                                            zIndex: 10,
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                            handleDragStart(`audio-end-${index}`);
                                          }}
                                          onMouseUp={handleDragEnd}
                                        ></button>
                                      </button>
                                    );
                                  })}
                                  </div>
                                </div>
                              );
                            });
                          })()}
                        </div>
                      ) : null}
                    </div>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorModal
        open={errorModal.open}
        title={errorModal.title}
        message={errorModal.message}
        onClose={closeErrorModal}
      />
      <KeyboardShortcutsModal isOpen={showShortcuts} onClose={() => setShowShortcuts(false)} />
      <ChatModal open={value?.isChatOpen} />
    </>
  );
};
export default Editing;
